//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ClientBase } from './clientBase';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase, HttpContext } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AgenciesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: AgencyCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgencyDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgencyDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgencyMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgencyMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgencyDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgencyDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgencyDto> {
        let url_ = this.baseUrl + "/agencies?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfAgencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfAgencyDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfAgencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfAgencyDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(agencyId: number, httpContext?: HttpContext): Observable<AgencyDto> {
        return this.getOne(agencyId, UnityViewType.Default, httpContext) as unknown as Observable<AgencyDto>;
    }            
                
    getOneAsMini(agencyId: number, httpContext?: HttpContext): Observable<AgencyMiniDto> {
        return this.getOne(agencyId, UnityViewType.Mini, httpContext) as unknown as Observable<AgencyMiniDto>;
    }            
                
    getOneAsDetailed(agencyId: number, httpContext?: HttpContext): Observable<AgencyDetailedDto> {
        return this.getOne(agencyId, UnityViewType.Detailed, httpContext) as unknown as Observable<AgencyDetailedDto>;
    }            
    
    

    private getOne(agencyId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<AgencyDto> {
        let url_ = this.baseUrl + "/agencies/{agencyId}?";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<AgencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgencyDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(agencyId: number, dto: AgencyUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agencies/{agencyId}";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateCommunitiesInOne(agencyId: number, communityIds: number[], httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/communities";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(communityIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateCommunitiesInOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateCommunitiesInOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCommunitiesInOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AgencyUsersClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(agencyId?: number | null | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgencyUserDto> {
        return this.getAll(agencyId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgencyUserDto>;
    }            
                
    getAllAsMini(agencyId?: number | null | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgencyUserMiniDto> {
        return this.getAll(agencyId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgencyUserMiniDto>;
    }            
                
    getAllAsDetailed(agencyId?: number | null | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgencyUserDetailedDto> {
        return this.getAll(agencyId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgencyUserDetailedDto>;
    }            
    
    

    private getAll(agencyId?: number | null | undefined, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgencyUserDto> {
        let url_ = this.baseUrl + "/agency-users?";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfAgencyUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfAgencyUserDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfAgencyUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfAgencyUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(userId: number, agencyId?: number | null | undefined, httpContext?: HttpContext): Observable<AgencyUserDto> {
        return this.getOne(userId, agencyId, UnityViewType.Default, httpContext) as unknown as Observable<AgencyUserDto>;
    }            
                
    getOneAsMini(userId: number, agencyId?: number | null | undefined, httpContext?: HttpContext): Observable<AgencyUserMiniDto> {
        return this.getOne(userId, agencyId, UnityViewType.Mini, httpContext) as unknown as Observable<AgencyUserMiniDto>;
    }            
                
    getOneAsDetailed(userId: number, agencyId?: number | null | undefined, httpContext?: HttpContext): Observable<AgencyUserDetailedDto> {
        return this.getOne(userId, agencyId, UnityViewType.Detailed, httpContext) as unknown as Observable<AgencyUserDetailedDto>;
    }            
    
    

    private getOne(userId: number, agencyId?: number | null | undefined, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<AgencyUserDto> {
        let url_ = this.baseUrl + "/agency-users/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyUserDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<AgencyUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgencyUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AgreementsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: AgreementCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgreementDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgreementMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<FilteredOfAgreementDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<FilteredOfAgreementDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementDto> {
        let url_ = this.baseUrl + "/agreements?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfAgreementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfAgreementDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfAgreementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForUserAsDefault(userId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementDto> {
        return this.getAllForUser(userId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgreementDto>;
    }            
                
    getAllForUserAsMini(userId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementMiniDto> {
        return this.getAllForUser(userId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgreementMiniDto>;
    }            
                
    getAllForUserAsDetailed(userId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<FilteredOfAgreementDetailedDto> {
        return this.getAllForUser(userId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<FilteredOfAgreementDetailedDto>;
    }            
    
    

    private getAllForUser(userId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementDto> {
        let url_ = this.baseUrl + "/users/{userId}/agreements?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfAgreementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfAgreementDto>;
        }));
    }

    protected processGetAllForUser(response: HttpResponseBase): Observable<PagingOfAgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfAgreementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(agreementId: number, httpContext?: HttpContext): Observable<AgreementDto> {
        return this.getOne(agreementId, UnityViewType.Default, httpContext) as unknown as Observable<AgreementDto>;
    }            
                
    getOneAsMini(agreementId: number, httpContext?: HttpContext): Observable<AgreementMiniDto> {
        return this.getOne(agreementId, UnityViewType.Mini, httpContext) as unknown as Observable<AgreementMiniDto>;
    }            
                
    getOneAsDetailed(agreementId: number, httpContext?: HttpContext): Observable<AgreementDetailedDto> {
        return this.getOne(agreementId, UnityViewType.Detailed, httpContext) as unknown as Observable<AgreementDetailedDto>;
    }            
                
    getOneAsStats(agreementId: number, httpContext?: HttpContext): Observable<AgreementStatsDto> {
        return this.getOne(agreementId, UnityViewType.Stats, httpContext) as unknown as Observable<AgreementStatsDto>;
    }            
    
    

    private getOne(agreementId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<AgreementDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<AgreementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgreementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(agreementId: number, dto: AgreementUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOne(agreementId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateCommunitiesInOne(agreementId: number, communityIds: number[], httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/communities";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(communityIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateCommunitiesInOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateCommunitiesInOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCommunitiesInOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AgreementUsersClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    addOneToAgreement(agreementId: number, dto: AgreementUserCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/users";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processAddOneToAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddOneToAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processAddOneToAgreement(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgreementAsDefault(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementUserDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgreementUserDto>;
    }            
                
    getAllForAgreementAsMini(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementUserMiniDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgreementUserMiniDto>;
    }            
                
    getAllForAgreementAsDetailed(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementUserDetailedDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfAgreementUserDetailedDto>;
    }            
    
    

    private getAllForAgreement(agreementId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfAgreementUserDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/users?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfAgreementUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfAgreementUserDto>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<PagingOfAgreementUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfAgreementUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneForAgreementAsDefault(agreementId: number, userId: number, httpContext?: HttpContext): Observable<AgreementUserDto> {
        return this.getOneForAgreement(agreementId, userId, UnityViewType.Default, httpContext) as unknown as Observable<AgreementUserDto>;
    }            
                
    getOneForAgreementAsMini(agreementId: number, userId: number, httpContext?: HttpContext): Observable<AgreementUserMiniDto> {
        return this.getOneForAgreement(agreementId, userId, UnityViewType.Mini, httpContext) as unknown as Observable<AgreementUserMiniDto>;
    }            
                
    getOneForAgreementAsDetailed(agreementId: number, userId: number, httpContext?: HttpContext): Observable<AgreementUserDetailedDto> {
        return this.getOneForAgreement(agreementId, userId, UnityViewType.Detailed, httpContext) as unknown as Observable<AgreementUserDetailedDto>;
    }            
    
    

    private getOneForAgreement(agreementId: number, userId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<AgreementUserDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/users/{userId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementUserDto>;
        }));
    }

    protected processGetOneForAgreement(response: HttpResponseBase): Observable<AgreementUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgreementUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOneFromAgreement(agreementId: number, userId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/users/{userId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOneFromAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOneFromAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOneFromAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssignableUsersClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    getForAgreement(agreementId: number, httpContext?: HttpContext): Observable<UserMiniDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/assignable-users";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMiniDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMiniDto[]>;
        }));
    }

    protected processGetForAgreement(response: HttpResponseBase): Observable<UserMiniDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserMiniDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AvailableTransitionsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForUserRoleAsDefault(agencyId: number, userId: number, roleId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForUserRole(agencyId, userId, roleId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForUserRoleAsMini(agencyId: number, userId: number, roleId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForUserRole(agencyId, userId, roleId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForUserRoleAsDetailed(agencyId: number, userId: number, roleId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForUserRole(agencyId, userId, roleId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForUserRole(agencyId: number, userId: number, roleId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/users/{userId}/roles/{roleId}/available-transitions?";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForUserRole(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForUserRole(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForUserRole(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgencyAsDefault(agencyId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForAgency(agencyId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForAgencyAsMini(agencyId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForAgency(agencyId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForAgencyAsDetailed(agencyId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForAgency(agencyId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForAgency(agencyId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/available-transitions?";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgency(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgency(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForAgency(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgencyUserAsDefault(agencyId: number, userId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForAgencyUser(agencyId, userId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForAgencyUserAsMini(agencyId: number, userId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForAgencyUser(agencyId, userId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForAgencyUserAsDetailed(agencyId: number, userId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForAgencyUser(agencyId, userId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForAgencyUser(agencyId: number, userId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/users/{userId}/available-transitions?";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgencyUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgencyUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForAgencyUser(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForUserAsDefault(userId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForUser(userId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForUserAsMini(userId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForUser(userId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForUserAsDetailed(userId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForUser(userId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForUser(userId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/users/{userId}/available-transitions?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForUser(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForProgramAsDefault(programId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForProgram(programId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForProgramAsMini(programId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForProgram(programId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForProgramAsDetailed(programId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForProgram(programId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForProgram(programId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/programs/{programId}/available-transitions?";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined.");
        url_ = url_.replace("{programId}", encodeURIComponent("" + programId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForProgram(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForProgram(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForProgram(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForFormSchemaAsDefault(formSchemaId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForFormSchema(formSchemaId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForFormSchemaAsMini(formSchemaId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForFormSchema(formSchemaId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForFormSchemaAsDetailed(formSchemaId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForFormSchema(formSchemaId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForFormSchema(formSchemaId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/form-schemas/{formSchemaId}/available-transitions?";
        if (formSchemaId === undefined || formSchemaId === null)
            throw new Error("The parameter 'formSchemaId' must be defined.");
        url_ = url_.replace("{formSchemaId}", encodeURIComponent("" + formSchemaId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForFormSchema(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForFormSchema(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForFormSchema(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForVendorAsDefault(vendorId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForVendor(vendorId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForVendorAsMini(vendorId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForVendor(vendorId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForVendorAsDetailed(vendorId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForVendor(vendorId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForVendor(vendorId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/vendors/{vendorId}/available-transitions?";
        if (vendorId === undefined || vendorId === null)
            throw new Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForVendor(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForVendor(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForVendor(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForCommunityAsDefault(communityId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForCommunity(communityId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForCommunityAsMini(communityId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForCommunity(communityId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForCommunityAsDetailed(communityId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForCommunity(communityId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForCommunity(communityId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/communities/{communityId}/available-transitions?";
        if (communityId === undefined || communityId === null)
            throw new Error("The parameter 'communityId' must be defined.");
        url_ = url_.replace("{communityId}", encodeURIComponent("" + communityId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForCommunity(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForCommunity(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForCommunity(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForFormResponseAsDefault(agreementId: number, formResponseId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForFormResponse(agreementId, formResponseId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForFormResponseAsMini(agreementId: number, formResponseId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForFormResponse(agreementId, formResponseId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForFormResponseAsDetailed(agreementId: number, formResponseId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForFormResponse(agreementId, formResponseId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForFormResponse(agreementId: number, formResponseId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses/{formResponseId}/available-transitions?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formResponseId === undefined || formResponseId === null)
            throw new Error("The parameter 'formResponseId' must be defined.");
        url_ = url_.replace("{formResponseId}", encodeURIComponent("" + formResponseId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForFormResponse(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForFormResponse(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForFormResponse(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgreementAsDefault(agreementId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForAgreement(agreementId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForAgreementAsMini(agreementId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForAgreement(agreementId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForAgreementAsDetailed(agreementId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForAgreement(agreementId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForAgreement(agreementId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/available-transitions?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForReferenceFileAsDefault(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForReferenceFile(agreementId, referenceFileId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForReferenceFileAsMini(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForReferenceFile(agreementId, referenceFileId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForReferenceFileAsDetailed(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForReferenceFile(agreementId, referenceFileId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForReferenceFile(agreementId: number, referenceFileId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/reference-files/{referenceFileId}/available-transitions?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (referenceFileId === undefined || referenceFileId === null)
            throw new Error("The parameter 'referenceFileId' must be defined.");
        url_ = url_.replace("{referenceFileId}", encodeURIComponent("" + referenceFileId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForReferenceFile(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForReferenceFile(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForReferenceFile(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForFormScheduleAsDefault(agreementId: number, formScheduleId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForFormSchedule(agreementId, formScheduleId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForFormScheduleAsMini(agreementId: number, formScheduleId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForFormSchedule(agreementId, formScheduleId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForFormScheduleAsDetailed(agreementId: number, formScheduleId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForFormSchedule(agreementId, formScheduleId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForFormSchedule(agreementId: number, formScheduleId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-schedules/{formScheduleId}/available-transitions?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formScheduleId === undefined || formScheduleId === null)
            throw new Error("The parameter 'formScheduleId' must be defined.");
        url_ = url_.replace("{formScheduleId}", encodeURIComponent("" + formScheduleId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForFormSchedule(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForFormSchedule(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForFormSchedule(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForDocumentAsDefault(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForDocument(agreementId, documentId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForDocumentAsMini(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForDocument(agreementId, documentId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForDocumentAsDetailed(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForDocument(agreementId, documentId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForDocument(agreementId: number, documentId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/documents/{documentId}/available-transitions?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForDocument(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForDocument(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForDocument(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForClientAsDefault(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForClient(agreementId, clientId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForClientAsMini(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForClient(agreementId, clientId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForClientAsDetailed(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForClient(agreementId, clientId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForClient(agreementId: number, clientId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/clients/{clientId}/available-transitions?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForClient(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForClient(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForClient(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForClientExpensesAsDefault(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForClientExpenses(agreementId, clientId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForClientExpensesAsMini(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForClientExpenses(agreementId, clientId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForClientExpensesAsDetailed(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForClientExpenses(agreementId, clientId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForClientExpenses(agreementId: number, clientId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/client-expenses/{clientId}/available-transitions?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForClientExpenses(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForClientExpenses(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForClientExpenses(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForDisbursementAsDefault(agreementId: number, disbursementId: number, httpContext?: HttpContext): Observable<TransitionDto[]> {
        return this.getAllForDisbursement(agreementId, disbursementId, UnityViewType.Default, httpContext) as unknown as Observable<TransitionDto[]>;
    }            
                
    getAllForDisbursementAsMini(agreementId: number, disbursementId: number, httpContext?: HttpContext): Observable<TransitionMiniDto[]> {
        return this.getAllForDisbursement(agreementId, disbursementId, UnityViewType.Mini, httpContext) as unknown as Observable<TransitionMiniDto[]>;
    }            
                
    getAllForDisbursementAsDetailed(agreementId: number, disbursementId: number, httpContext?: HttpContext): Observable<TransitionDetailedDto[]> {
        return this.getAllForDisbursement(agreementId, disbursementId, UnityViewType.Detailed, httpContext) as unknown as Observable<TransitionDetailedDto[]>;
    }            
    
    

    private getAllForDisbursement(agreementId: number, disbursementId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<TransitionDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/disbursements/{disbursementId}/available-transitions?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (disbursementId === undefined || disbursementId === null)
            throw new Error("The parameter 'disbursementId' must be defined.");
        url_ = url_.replace("{disbursementId}", encodeURIComponent("" + disbursementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForDisbursement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForDisbursement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransitionDto[]>;
        }));
    }

    protected processGetAllForDisbursement(response: HttpResponseBase): Observable<TransitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TransitionDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClientExpensesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOneForAgreement(agreementId: number, dto: ClientExpenseCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/client-expenses";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOneForAgreement(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgreementAsDefault(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfClientExpenseDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfClientExpenseDto>;
    }            
                
    getAllForAgreementAsMini(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfClientExpenseMiniDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfClientExpenseMiniDto>;
    }            
                
    getAllForAgreementAsDetailed(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfClientExpenseDetailedDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfClientExpenseDetailedDto>;
    }            
    
    

    private getAllForAgreement(agreementId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfClientExpenseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/client-expenses?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfClientExpenseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfClientExpenseDto>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<PagingOfClientExpenseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfClientExpenseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneForAgreementAsDefault(agreementId: number, clientExpenseId: number, httpContext?: HttpContext): Observable<ClientExpenseDto> {
        return this.getOneForAgreement(agreementId, clientExpenseId, UnityViewType.Default, httpContext) as unknown as Observable<ClientExpenseDto>;
    }            
                
    getOneForAgreementAsMini(agreementId: number, clientExpenseId: number, httpContext?: HttpContext): Observable<ClientExpenseMiniDto> {
        return this.getOneForAgreement(agreementId, clientExpenseId, UnityViewType.Mini, httpContext) as unknown as Observable<ClientExpenseMiniDto>;
    }            
                
    getOneForAgreementAsDetailed(agreementId: number, clientExpenseId: number, httpContext?: HttpContext): Observable<ClientExpenseDetailedDto> {
        return this.getOneForAgreement(agreementId, clientExpenseId, UnityViewType.Detailed, httpContext) as unknown as Observable<ClientExpenseDetailedDto>;
    }            
    
    

    private getOneForAgreement(agreementId: number, clientExpenseId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<ClientExpenseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/client-expenses/{clientExpenseId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientExpenseId === undefined || clientExpenseId === null)
            throw new Error("The parameter 'clientExpenseId' must be defined.");
        url_ = url_.replace("{clientExpenseId}", encodeURIComponent("" + clientExpenseId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientExpenseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientExpenseDto>;
        }));
    }

    protected processGetOneForAgreement(response: HttpResponseBase): Observable<ClientExpenseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientExpenseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOneForAgreement(agreementId: number, clientExpenseId: number, dto: ClientExpenseUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/client-expenses/{clientExpenseId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientExpenseId === undefined || clientExpenseId === null)
            throw new Error("The parameter 'clientExpenseId' must be defined.");
        url_ = url_.replace("{clientExpenseId}", encodeURIComponent("" + clientExpenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOneForAgreement(agreementId: number, clientExpenseId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/client-expenses/{clientExpenseId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientExpenseId === undefined || clientExpenseId === null)
            throw new Error("The parameter 'clientExpenseId' must be defined.");
        url_ = url_.replace("{clientExpenseId}", encodeURIComponent("" + clientExpenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ClientsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOneForAgreement(agreementId: number, dto: ClientCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/clients";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOneForAgreement(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgreementAsDefault(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfClientDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfClientDto>;
    }            
                
    getAllForAgreementAsMini(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfClientMiniDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfClientMiniDto>;
    }            
                
    getAllForAgreementAsDetailed(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfClientDetailedDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfClientDetailedDto>;
    }            
    
    

    private getAllForAgreement(agreementId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfClientDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/clients?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfClientDto>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<PagingOfClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfClientDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneForAgreementAsDefault(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<ClientDto> {
        return this.getOneForAgreement(agreementId, clientId, UnityViewType.Default, httpContext) as unknown as Observable<ClientDto>;
    }            
                
    getOneForAgreementAsMini(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<ClientMiniDto> {
        return this.getOneForAgreement(agreementId, clientId, UnityViewType.Mini, httpContext) as unknown as Observable<ClientMiniDto>;
    }            
                
    getOneForAgreementAsDetailed(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<ClientDetailedDto> {
        return this.getOneForAgreement(agreementId, clientId, UnityViewType.Detailed, httpContext) as unknown as Observable<ClientDetailedDto>;
    }            
    
    

    private getOneForAgreement(agreementId: number, clientId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<ClientDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/clients/{clientId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto>;
        }));
    }

    protected processGetOneForAgreement(response: HttpResponseBase): Observable<ClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOneForAgreement(agreementId: number, clientId: number, dto: ClientUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/clients/{clientId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOneForAgreement(agreementId: number, clientId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/clients/{clientId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CommunitiesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: CommunityCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/communities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfCommunityDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfCommunityDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfCommunityMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfCommunityMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfCommunityDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfCommunityDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfCommunityDto> {
        let url_ = this.baseUrl + "/communities?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfCommunityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfCommunityDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfCommunityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfCommunityDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(communityId: number, httpContext?: HttpContext): Observable<CommunityDto> {
        return this.getOne(communityId, UnityViewType.Default, httpContext) as unknown as Observable<CommunityDto>;
    }            
                
    getOneAsMini(communityId: number, httpContext?: HttpContext): Observable<CommunityMiniDto> {
        return this.getOne(communityId, UnityViewType.Mini, httpContext) as unknown as Observable<CommunityMiniDto>;
    }            
                
    getOneAsDetailed(communityId: number, httpContext?: HttpContext): Observable<CommunityDetailedDto> {
        return this.getOne(communityId, UnityViewType.Detailed, httpContext) as unknown as Observable<CommunityDetailedDto>;
    }            
    
    

    private getOne(communityId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<CommunityDto> {
        let url_ = this.baseUrl + "/communities/{communityId}?";
        if (communityId === undefined || communityId === null)
            throw new Error("The parameter 'communityId' must be defined.");
        url_ = url_.replace("{communityId}", encodeURIComponent("" + communityId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunityDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<CommunityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommunityDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(communityId: number, dto: CommunityUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/communities/{communityId}";
        if (communityId === undefined || communityId === null)
            throw new Error("The parameter 'communityId' must be defined.");
        url_ = url_.replace("{communityId}", encodeURIComponent("" + communityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DisbursementsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOneForAgreement(agreementId: number, dto: DisbursementCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/disbursements";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOneForAgreement(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgreementAsDefault(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfDisbursementDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfDisbursementDto>;
    }            
                
    getAllForAgreementAsMini(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfDisbursementMiniDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfDisbursementMiniDto>;
    }            
                
    getAllForAgreementAsDetailed(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfDisbursementDetailedDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfDisbursementDetailedDto>;
    }            
    
    

    private getAllForAgreement(agreementId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfDisbursementDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/disbursements?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfDisbursementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfDisbursementDto>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<PagingOfDisbursementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfDisbursementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneForAgreementAsDefault(agreementId: number, disbursementId: number, httpContext?: HttpContext): Observable<DisbursementDto> {
        return this.getOneForAgreement(agreementId, disbursementId, UnityViewType.Default, httpContext) as unknown as Observable<DisbursementDto>;
    }            
                
    getOneForAgreementAsMini(agreementId: number, disbursementId: number, httpContext?: HttpContext): Observable<DisbursementMiniDto> {
        return this.getOneForAgreement(agreementId, disbursementId, UnityViewType.Mini, httpContext) as unknown as Observable<DisbursementMiniDto>;
    }            
                
    getOneForAgreementAsDetailed(agreementId: number, disbursementId: number, httpContext?: HttpContext): Observable<DisbursementDetailedDto> {
        return this.getOneForAgreement(agreementId, disbursementId, UnityViewType.Detailed, httpContext) as unknown as Observable<DisbursementDetailedDto>;
    }            
    
    

    private getOneForAgreement(agreementId: number, disbursementId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<DisbursementDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/disbursements/{disbursementId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (disbursementId === undefined || disbursementId === null)
            throw new Error("The parameter 'disbursementId' must be defined.");
        url_ = url_.replace("{disbursementId}", encodeURIComponent("" + disbursementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisbursementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisbursementDto>;
        }));
    }

    protected processGetOneForAgreement(response: HttpResponseBase): Observable<DisbursementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DisbursementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOneForAgreement(agreementId: number, disbursementId: number, dto: DisbursementUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/disbursements/{disbursementId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (disbursementId === undefined || disbursementId === null)
            throw new Error("The parameter 'disbursementId' must be defined.");
        url_ = url_.replace("{disbursementId}", encodeURIComponent("" + disbursementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOneForAgreement(agreementId: number, disbursementId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/disbursements/{disbursementId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (disbursementId === undefined || disbursementId === null)
            throw new Error("The parameter 'disbursementId' must be defined.");
        url_ = url_.replace("{disbursementId}", encodeURIComponent("" + disbursementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOneForAgreement(agreementId: number, dto: DocumentCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/documents";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOneForAgreement(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgreementAsDefault(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfDocumentDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfDocumentDto>;
    }            
                
    getAllForAgreementAsMini(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfDocumentMiniDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfDocumentMiniDto>;
    }            
                
    getAllForAgreementAsDetailed(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfDocumentDetailedDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfDocumentDetailedDto>;
    }            
    
    

    private getAllForAgreement(agreementId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfDocumentDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/documents?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfDocumentDto>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<PagingOfDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneForAgreementAsDefault(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<DocumentDto> {
        return this.getOneForAgreement(agreementId, documentId, UnityViewType.Default, httpContext) as unknown as Observable<DocumentDto>;
    }            
                
    getOneForAgreementAsMini(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<DocumentMiniDto> {
        return this.getOneForAgreement(agreementId, documentId, UnityViewType.Mini, httpContext) as unknown as Observable<DocumentMiniDto>;
    }            
                
    getOneForAgreementAsDetailed(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<DocumentDetailedDto> {
        return this.getOneForAgreement(agreementId, documentId, UnityViewType.Detailed, httpContext) as unknown as Observable<DocumentDetailedDto>;
    }            
    
    

    private getOneForAgreement(agreementId: number, documentId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/documents/{documentId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processGetOneForAgreement(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOneForAgreement(agreementId: number, documentId: number, dto: DocumentUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/documents/{documentId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOneForAgreement(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/documents/{documentId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    downloadOneForAgreement(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/documents/{documentId}/download";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDownloadOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDownloadOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOneForAgreement(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EntitlementsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfEntitlementDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfEntitlementDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfEntitlementMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfEntitlementMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfEntitlementDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfEntitlementDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfEntitlementDto> {
        let url_ = this.baseUrl + "/entitlements?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfEntitlementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfEntitlementDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfEntitlementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfEntitlementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FacetsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    getAllForAgreement(httpContext?: HttpContext): Observable<FacetResponseDto> {
        let url_ = this.baseUrl + "/facets/agreement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacetResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacetResponseDto>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<FacetResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FacetResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FeaturesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    getAll(httpContext?: HttpContext): Observable<FeatureDto[]> {
        let url_ = this.baseUrl + "/features";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FeatureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormInstancesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOneForAgreement(agreementId: number, dto: FormInstanceCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-instances";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOneForAgreement(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgreementAsDefault(agreementId: number, formScheduleId?: number | null | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormInstanceDto> {
        return this.getAllForAgreement(agreementId, formScheduleId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormInstanceDto>;
    }            
                
    getAllForAgreementAsMini(agreementId: number, formScheduleId?: number | null | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormInstanceMiniDto> {
        return this.getAllForAgreement(agreementId, formScheduleId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormInstanceMiniDto>;
    }            
                
    getAllForAgreementAsDetailed(agreementId: number, formScheduleId?: number | null | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormInstanceDetailedDto> {
        return this.getAllForAgreement(agreementId, formScheduleId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormInstanceDetailedDto>;
    }            
    
    

    private getAllForAgreement(agreementId: number, formScheduleId?: number | null | undefined, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormInstanceDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-instances?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formScheduleId !== undefined && formScheduleId !== null)
            url_ += "formScheduleId=" + encodeURIComponent("" + formScheduleId) + "&";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfFormInstanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfFormInstanceDto>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<PagingOfFormInstanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfFormInstanceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneForAgreementAsDefault(agreementId: number, formInstanceId: number, httpContext?: HttpContext): Observable<FormInstanceDto> {
        return this.getOneForAgreement(agreementId, formInstanceId, UnityViewType.Default, httpContext) as unknown as Observable<FormInstanceDto>;
    }            
                
    getOneForAgreementAsMini(agreementId: number, formInstanceId: number, httpContext?: HttpContext): Observable<FormInstanceMiniDto> {
        return this.getOneForAgreement(agreementId, formInstanceId, UnityViewType.Mini, httpContext) as unknown as Observable<FormInstanceMiniDto>;
    }            
                
    getOneForAgreementAsDetailed(agreementId: number, formInstanceId: number, httpContext?: HttpContext): Observable<FormInstanceDetailedDto> {
        return this.getOneForAgreement(agreementId, formInstanceId, UnityViewType.Detailed, httpContext) as unknown as Observable<FormInstanceDetailedDto>;
    }            
    
    

    private getOneForAgreement(agreementId: number, formInstanceId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<FormInstanceDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-instances/{formInstanceId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formInstanceId === undefined || formInstanceId === null)
            throw new Error("The parameter 'formInstanceId' must be defined.");
        url_ = url_.replace("{formInstanceId}", encodeURIComponent("" + formInstanceId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormInstanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormInstanceDto>;
        }));
    }

    protected processGetOneForAgreement(response: HttpResponseBase): Observable<FormInstanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormInstanceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOneForAgreement(agreementId: number, instanceId: number, dto: FormInstanceUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-instances/{instanceId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOneForAgreement(agreementId: number, instanceId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-instances/{instanceId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (instanceId === undefined || instanceId === null)
            throw new Error("The parameter 'instanceId' must be defined.");
        url_ = url_.replace("{instanceId}", encodeURIComponent("" + instanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormResponsesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneForAgreementAsDefault(agreementId: number, responseId: number, httpContext?: HttpContext): Observable<FormResponseDto> {
        return this.getOneForAgreement(agreementId, responseId, UnityViewType.Default, httpContext) as unknown as Observable<FormResponseDto>;
    }            
                
    getOneForAgreementAsMini(agreementId: number, responseId: number, httpContext?: HttpContext): Observable<FormResponseMiniDto> {
        return this.getOneForAgreement(agreementId, responseId, UnityViewType.Mini, httpContext) as unknown as Observable<FormResponseMiniDto>;
    }            
                
    getOneForAgreementAsDetailed(agreementId: number, responseId: number, httpContext?: HttpContext): Observable<FormResponseDetailedDto> {
        return this.getOneForAgreement(agreementId, responseId, UnityViewType.Detailed, httpContext) as unknown as Observable<FormResponseDetailedDto>;
    }            
    
    

    private getOneForAgreement(agreementId: number, responseId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<FormResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses/{responseId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (responseId === undefined || responseId === null)
            throw new Error("The parameter 'responseId' must be defined.");
        url_ = url_.replace("{responseId}", encodeURIComponent("" + responseId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormResponseDto>;
        }));
    }

    protected processGetOneForAgreement(response: HttpResponseBase): Observable<FormResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOneForAgreement(agreementId: number, responseId: number, dto: FormResponseUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses/{responseId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (responseId === undefined || responseId === null)
            throw new Error("The parameter 'responseId' must be defined.");
        url_ = url_.replace("{responseId}", encodeURIComponent("" + responseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOneForAgreement(agreementId: number, responseId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses/{responseId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (responseId === undefined || responseId === null)
            throw new Error("The parameter 'responseId' must be defined.");
        url_ = url_.replace("{responseId}", encodeURIComponent("" + responseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    downloadOneForAgreement(agreementId: number, responseId: number, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses/{responseId}/download";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (responseId === undefined || responseId === null)
            throw new Error("The parameter 'responseId' must be defined.");
        url_ = url_.replace("{responseId}", encodeURIComponent("" + responseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDownloadOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDownloadOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOneForAgreement(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    createOneForAgreement(agreementId: number, dto: FormResponseCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOneForAgreement(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForSchemaAsDefault(schemaId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormResponseDto> {
        return this.getAllForSchema(schemaId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormResponseDto>;
    }            
                
    getAllForSchemaAsMini(schemaId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormResponseMiniDto> {
        return this.getAllForSchema(schemaId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormResponseMiniDto>;
    }            
                
    getAllForSchemaAsDetailed(schemaId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormResponseDetailedDto> {
        return this.getAllForSchema(schemaId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormResponseDetailedDto>;
    }            
    
    

    private getAllForSchema(schemaId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormResponseDto> {
        let url_ = this.baseUrl + "/form-schemas/{schemaId}/responses?";
        if (schemaId === undefined || schemaId === null)
            throw new Error("The parameter 'schemaId' must be defined.");
        url_ = url_.replace("{schemaId}", encodeURIComponent("" + schemaId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForSchema(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForSchema(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfFormResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfFormResponseDto>;
        }));
    }

    protected processGetAllForSchema(response: HttpResponseBase): Observable<PagingOfFormResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfFormResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormSchedulesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOneForAgreement(agreementId: number, dto: FormScheduleCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-schedules";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOneForAgreement(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgreementAsDefault(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormScheduleDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormScheduleDto>;
    }            
                
    getAllForAgreementAsMini(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormScheduleMiniDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormScheduleMiniDto>;
    }            
                
    getAllForAgreementAsDetailed(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormScheduleDetailedDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormScheduleDetailedDto>;
    }            
    
    

    private getAllForAgreement(agreementId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormScheduleDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-schedules?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfFormScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfFormScheduleDto>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<PagingOfFormScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfFormScheduleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneForAgreementAsDefault(agreementId: number, scheduleId: number, httpContext?: HttpContext): Observable<FormScheduleDto> {
        return this.getOneForAgreement(agreementId, scheduleId, UnityViewType.Default, httpContext) as unknown as Observable<FormScheduleDto>;
    }            
                
    getOneForAgreementAsMini(agreementId: number, scheduleId: number, httpContext?: HttpContext): Observable<FormScheduleMiniDto> {
        return this.getOneForAgreement(agreementId, scheduleId, UnityViewType.Mini, httpContext) as unknown as Observable<FormScheduleMiniDto>;
    }            
                
    getOneForAgreementAsDetailed(agreementId: number, scheduleId: number, httpContext?: HttpContext): Observable<FormScheduleDetailedDto> {
        return this.getOneForAgreement(agreementId, scheduleId, UnityViewType.Detailed, httpContext) as unknown as Observable<FormScheduleDetailedDto>;
    }            
    
    

    private getOneForAgreement(agreementId: number, scheduleId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<FormScheduleDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-schedules/{scheduleId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormScheduleDto>;
        }));
    }

    protected processGetOneForAgreement(response: HttpResponseBase): Observable<FormScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormScheduleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOneForAgreement(agreementId: number, scheduleId: number, dto: FormScheduleUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-schedules/{scheduleId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOneForAgreement(agreementId: number, scheduleId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-schedules/{scheduleId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormTemplateClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: FormSchemaCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/form-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormSchemaDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormSchemaDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormSchemaMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormSchemaMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormSchemaDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormSchemaDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormSchemaDto> {
        let url_ = this.baseUrl + "/form-template?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfFormSchemaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfFormSchemaDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfFormSchemaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfFormSchemaDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(formSchemaId: number, httpContext?: HttpContext): Observable<FormSchemaDto> {
        return this.getOne(formSchemaId, UnityViewType.Default, httpContext) as unknown as Observable<FormSchemaDto>;
    }            
                
    getOneAsMini(formSchemaId: number, httpContext?: HttpContext): Observable<FormSchemaMiniDto> {
        return this.getOne(formSchemaId, UnityViewType.Mini, httpContext) as unknown as Observable<FormSchemaMiniDto>;
    }            
                
    getOneAsDetailed(formSchemaId: number, httpContext?: HttpContext): Observable<FormSchemaDetailedDto> {
        return this.getOne(formSchemaId, UnityViewType.Detailed, httpContext) as unknown as Observable<FormSchemaDetailedDto>;
    }            
    
    

    private getOne(formSchemaId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<FormSchemaDto> {
        let url_ = this.baseUrl + "/form-template/{formSchemaId}?";
        if (formSchemaId === undefined || formSchemaId === null)
            throw new Error("The parameter 'formSchemaId' must be defined.");
        url_ = url_.replace("{formSchemaId}", encodeURIComponent("" + formSchemaId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormSchemaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormSchemaDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<FormSchemaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormSchemaDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(formSchemaId: number, dto: FormSchemaUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/form-template/{formSchemaId}";
        if (formSchemaId === undefined || formSchemaId === null)
            throw new Error("The parameter 'formSchemaId' must be defined.");
        url_ = url_.replace("{formSchemaId}", encodeURIComponent("" + formSchemaId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOne(formSchemaId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/form-template/{formSchemaId}";
        if (formSchemaId === undefined || formSchemaId === null)
            throw new Error("The parameter 'formSchemaId' must be defined.");
        url_ = url_.replace("{formSchemaId}", encodeURIComponent("" + formSchemaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormTypesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormTypeDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormTypeDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormTypeMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormTypeMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormTypeDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfFormTypeDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfFormTypeDto> {
        let url_ = this.baseUrl + "/form-types?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfFormTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfFormTypeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfFormTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfFormTypeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(formTypeId: number, httpContext?: HttpContext): Observable<FormTypeDto> {
        return this.getOne(formTypeId, UnityViewType.Default, httpContext) as unknown as Observable<FormTypeDto>;
    }            
                
    getOneAsMini(formTypeId: number, httpContext?: HttpContext): Observable<FormTypeMiniDto> {
        return this.getOne(formTypeId, UnityViewType.Mini, httpContext) as unknown as Observable<FormTypeMiniDto>;
    }            
                
    getOneAsDetailed(formTypeId: number, httpContext?: HttpContext): Observable<FormTypeDetailedDto> {
        return this.getOne(formTypeId, UnityViewType.Detailed, httpContext) as unknown as Observable<FormTypeDetailedDto>;
    }            
    
    

    private getOne(formTypeId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<FormTypeDto> {
        let url_ = this.baseUrl + "/form-types/{formTypeId}?";
        if (formTypeId === undefined || formTypeId === null)
            throw new Error("The parameter 'formTypeId' must be defined.");
        url_ = url_.replace("{formTypeId}", encodeURIComponent("" + formTypeId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormTypeDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<FormTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormTypeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormUploadsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    getAllForResponseForAgreement(agreementId: number, formResponseId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUploadDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses/{formResponseId}/form-uploads?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formResponseId === undefined || formResponseId === null)
            throw new Error("The parameter 'formResponseId' must be defined.");
        url_ = url_.replace("{formResponseId}", encodeURIComponent("" + formResponseId));
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForResponseForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForResponseForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfUploadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfUploadDto>;
        }));
    }

    protected processGetAllForResponseForAgreement(response: HttpResponseBase): Observable<PagingOfUploadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfUploadDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    downloadOneForResponseForAgreement(agreementId: number, formResponseId: number, uploadId: number, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses/{formResponseId}/form-uploads/{uploadId}/download";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formResponseId === undefined || formResponseId === null)
            throw new Error("The parameter 'formResponseId' must be defined.");
        url_ = url_.replace("{formResponseId}", encodeURIComponent("" + formResponseId));
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDownloadOneForResponseForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDownloadOneForResponseForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOneForResponseForAgreement(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InternalUsersClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: InternalUserCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/internal-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PermissionMasksClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    getForRole(roleId: number, httpContext?: HttpContext): Observable<PermissionMaskDto> {
        let url_ = this.baseUrl + "/roles/{roleId}/permission-masks";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForRole(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForRole(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionMaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionMaskDto>;
        }));
    }

    protected processGetForRole(response: HttpResponseBase): Observable<PermissionMaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PermissionMaskDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForRole(roleId: number, permissionDto: PermissionMaskDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/roles/{roleId}/permission-masks";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForRole(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForRole(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProgramsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: ProgramCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/programs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfProgramDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfProgramDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfProgramMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfProgramMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfProgramDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfProgramDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfProgramDto> {
        let url_ = this.baseUrl + "/programs?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfProgramDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfProgramDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfProgramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfProgramDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(programId: number, httpContext?: HttpContext): Observable<ProgramDto> {
        return this.getOne(programId, UnityViewType.Default, httpContext) as unknown as Observable<ProgramDto>;
    }            
                
    getOneAsMini(programId: number, httpContext?: HttpContext): Observable<ProgramMiniDto> {
        return this.getOne(programId, UnityViewType.Mini, httpContext) as unknown as Observable<ProgramMiniDto>;
    }            
                
    getOneAsDetailed(programId: number, httpContext?: HttpContext): Observable<ProgramDetailedDto> {
        return this.getOne(programId, UnityViewType.Detailed, httpContext) as unknown as Observable<ProgramDetailedDto>;
    }            
    
    

    private getOne(programId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<ProgramDto> {
        let url_ = this.baseUrl + "/programs/{programId}?";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined.");
        url_ = url_.replace("{programId}", encodeURIComponent("" + programId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgramDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgramDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<ProgramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgramDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(programId: number, dto: ProgramUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/programs/{programId}";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined.");
        url_ = url_.replace("{programId}", encodeURIComponent("" + programId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOne(programId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/programs/{programId}";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined.");
        url_ = url_.replace("{programId}", encodeURIComponent("" + programId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReferenceFilesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOneForAgreement(agreementId: number, dto: ReferenceFileCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/reference-files";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOneForAgreement(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForAgreementAsDefault(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfReferenceFileDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfReferenceFileDto>;
    }            
                
    getAllForAgreementAsMini(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfReferenceFileMiniDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfReferenceFileMiniDto>;
    }            
                
    getAllForAgreementAsDetailed(agreementId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfReferenceFileDetailedDto> {
        return this.getAllForAgreement(agreementId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfReferenceFileDetailedDto>;
    }            
    
    

    private getAllForAgreement(agreementId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfReferenceFileDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/reference-files?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfReferenceFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfReferenceFileDto>;
        }));
    }

    protected processGetAllForAgreement(response: HttpResponseBase): Observable<PagingOfReferenceFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfReferenceFileDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneForAgreementAsDefault(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<ReferenceFileDto> {
        return this.getOneForAgreement(agreementId, referenceFileId, UnityViewType.Default, httpContext) as unknown as Observable<ReferenceFileDto>;
    }            
                
    getOneForAgreementAsMini(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<ReferenceFileMiniDto> {
        return this.getOneForAgreement(agreementId, referenceFileId, UnityViewType.Mini, httpContext) as unknown as Observable<ReferenceFileMiniDto>;
    }            
                
    getOneForAgreementAsDetailed(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<ReferenceFileDetailedDto> {
        return this.getOneForAgreement(agreementId, referenceFileId, UnityViewType.Detailed, httpContext) as unknown as Observable<ReferenceFileDetailedDto>;
    }            
    
    

    private getOneForAgreement(agreementId: number, referenceFileId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<ReferenceFileDto> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/reference-files/{referenceFileId}?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (referenceFileId === undefined || referenceFileId === null)
            throw new Error("The parameter 'referenceFileId' must be defined.");
        url_ = url_.replace("{referenceFileId}", encodeURIComponent("" + referenceFileId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferenceFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferenceFileDto>;
        }));
    }

    protected processGetOneForAgreement(response: HttpResponseBase): Observable<ReferenceFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReferenceFileDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOneForAgreement(agreementId: number, referenceFileId: number, dto: ReferenceFileUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/reference-files/{referenceFileId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (referenceFileId === undefined || referenceFileId === null)
            throw new Error("The parameter 'referenceFileId' must be defined.");
        url_ = url_.replace("{referenceFileId}", encodeURIComponent("" + referenceFileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOneForAgreement(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/reference-files/{referenceFileId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (referenceFileId === undefined || referenceFileId === null)
            throw new Error("The parameter 'referenceFileId' must be defined.");
        url_ = url_.replace("{referenceFileId}", encodeURIComponent("" + referenceFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOneForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    downloadOneForAgreement(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/reference-files/{referenceFileId}/download";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (referenceFileId === undefined || referenceFileId === null)
            throw new Error("The parameter 'referenceFileId' must be defined.");
        url_ = url_.replace("{referenceFileId}", encodeURIComponent("" + referenceFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDownloadOneForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDownloadOneForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOneForAgreement(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReportsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfReportDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfReportDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfReportMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfReportMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfReportDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfReportDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfReportDto> {
        let url_ = this.baseUrl + "/reports?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfReportDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(reportId: number, httpContext?: HttpContext): Observable<ReportDto> {
        return this.getOne(reportId, UnityViewType.Default, httpContext) as unknown as Observable<ReportDto>;
    }            
                
    getOneAsMini(reportId: number, httpContext?: HttpContext): Observable<ReportMiniDto> {
        return this.getOne(reportId, UnityViewType.Mini, httpContext) as unknown as Observable<ReportMiniDto>;
    }            
                
    getOneAsDetailed(reportId: number, httpContext?: HttpContext): Observable<ReportDetailedDto> {
        return this.getOne(reportId, UnityViewType.Detailed, httpContext) as unknown as Observable<ReportDetailedDto>;
    }            
    
    

    private getOne(reportId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<ReportDto> {
        let url_ = this.baseUrl + "/reports/{reportId}?";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    downloadOne(reportId: number, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/reports/{reportId}/download";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDownloadOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDownloadOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOne(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RolesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: RoleCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(agencyId?: number | null | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfRoleDto> {
        return this.getAll(agencyId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfRoleDto>;
    }            
                
    getAllAsMini(agencyId?: number | null | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfRoleMiniDto> {
        return this.getAll(agencyId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfRoleMiniDto>;
    }            
                
    getAllAsDetailed(agencyId?: number | null | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfRoleDetailedDto> {
        return this.getAll(agencyId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfRoleDetailedDto>;
    }            
    
    

    private getAll(agencyId?: number | null | undefined, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfRoleDto> {
        let url_ = this.baseUrl + "/roles?";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfRoleDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfRoleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(roleId: number, httpContext?: HttpContext): Observable<RoleDto> {
        return this.getOne(roleId, UnityViewType.Default, httpContext) as unknown as Observable<RoleDto>;
    }            
                
    getOneAsMini(roleId: number, httpContext?: HttpContext): Observable<RoleMiniDto> {
        return this.getOne(roleId, UnityViewType.Mini, httpContext) as unknown as Observable<RoleMiniDto>;
    }            
                
    getOneAsDetailed(roleId: number, httpContext?: HttpContext): Observable<RoleDetailedDto> {
        return this.getOne(roleId, UnityViewType.Detailed, httpContext) as unknown as Observable<RoleDetailedDto>;
    }            
    
    

    private getOne(roleId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<RoleDto> {
        let url_ = this.baseUrl + "/roles/{roleId}?";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(roleId: number, dto: RoleUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOne(roleId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllChildrenForRoleAsDefault(roleId: number, httpContext?: HttpContext): Observable<RoleDto[]> {
        return this.getAllChildrenForRole(roleId, UnityViewType.Default, httpContext) as unknown as Observable<RoleDto[]>;
    }            
                
    getAllChildrenForRoleAsMini(roleId: number, httpContext?: HttpContext): Observable<RoleMiniDto[]> {
        return this.getAllChildrenForRole(roleId, UnityViewType.Mini, httpContext) as unknown as Observable<RoleMiniDto[]>;
    }            
                
    getAllChildrenForRoleAsDetailed(roleId: number, httpContext?: HttpContext): Observable<RoleDetailedDto[]> {
        return this.getAllChildrenForRole(roleId, UnityViewType.Detailed, httpContext) as unknown as Observable<RoleDetailedDto[]>;
    }            
    
    

    private getAllChildrenForRole(roleId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<RoleDto[]> {
        let url_ = this.baseUrl + "/roles/{roleId}/children?";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllChildrenForRole(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllChildrenForRole(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto[]>;
        }));
    }

    protected processGetAllChildrenForRole(response: HttpResponseBase): Observable<RoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAvailableForAgencyUserAsDefault(agencyId: number, userId: number, httpContext?: HttpContext): Observable<RoleDto[]> {
        return this.getAllAvailableForAgencyUser(agencyId, userId, UnityViewType.Default, httpContext) as unknown as Observable<RoleDto[]>;
    }            
                
    getAllAvailableForAgencyUserAsMini(agencyId: number, userId: number, httpContext?: HttpContext): Observable<RoleMiniDto[]> {
        return this.getAllAvailableForAgencyUser(agencyId, userId, UnityViewType.Mini, httpContext) as unknown as Observable<RoleMiniDto[]>;
    }            
                
    getAllAvailableForAgencyUserAsDetailed(agencyId: number, userId: number, httpContext?: HttpContext): Observable<RoleDetailedDto[]> {
        return this.getAllAvailableForAgencyUser(agencyId, userId, UnityViewType.Detailed, httpContext) as unknown as Observable<RoleDetailedDto[]>;
    }            
    
    

    private getAllAvailableForAgencyUser(agencyId: number, userId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<RoleDto[]> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/users/{userId}/available-roles?";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllAvailableForAgencyUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllAvailableForAgencyUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto[]>;
        }));
    }

    protected processGetAllAvailableForAgencyUser(response: HttpResponseBase): Observable<RoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ScheduleTypesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfScheduleTypeDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfScheduleTypeDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfScheduleTypeMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfScheduleTypeMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfScheduleTypeDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfScheduleTypeDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfScheduleTypeDto> {
        let url_ = this.baseUrl + "/schedule-types?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfScheduleTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfScheduleTypeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfScheduleTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfScheduleTypeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SubscriptionsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: SubscriptionCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfSubscriptionDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfSubscriptionDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfSubscriptionMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfSubscriptionMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfSubscriptionDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfSubscriptionDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfSubscriptionDto> {
        let url_ = this.baseUrl + "/subscriptions?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfSubscriptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfSubscriptionDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfSubscriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfSubscriptionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(subscriptionId: number, httpContext?: HttpContext): Observable<SubscriptionDto> {
        return this.getOne(subscriptionId, UnityViewType.Default, httpContext) as unknown as Observable<SubscriptionDto>;
    }            
                
    getOneAsMini(subscriptionId: number, httpContext?: HttpContext): Observable<SubscriptionMiniDto> {
        return this.getOne(subscriptionId, UnityViewType.Mini, httpContext) as unknown as Observable<SubscriptionMiniDto>;
    }            
                
    getOneAsDetailed(subscriptionId: number, httpContext?: HttpContext): Observable<SubscriptionDetailedDto> {
        return this.getOne(subscriptionId, UnityViewType.Detailed, httpContext) as unknown as Observable<SubscriptionDetailedDto>;
    }            
    
    

    private getOne(subscriptionId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<SubscriptionDto> {
        let url_ = this.baseUrl + "/subscriptions/{subscriptionId}?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<SubscriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOne(subscriptionId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/subscriptions/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TransitionsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    setForUserRole(agencyId: number, userId: number, roleId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/users/{userId}/roles/{roleId}/transitions";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForUserRole(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForUserRole(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForUserRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForAgency(agencyId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/transitions";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForAgency(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForAgency(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForAgency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForUser(userId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/users/{userId}/transitions";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForProgram(programId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/programs/{programId}/transitions";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined.");
        url_ = url_.replace("{programId}", encodeURIComponent("" + programId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForProgram(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForProgram(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForProgram(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForVendor(vendorId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/vendors/{vendorId}/transitions";
        if (vendorId === undefined || vendorId === null)
            throw new Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForVendor(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForVendor(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForVendor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForCommunity(communityId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/communities/{communityId}/transitions";
        if (communityId === undefined || communityId === null)
            throw new Error("The parameter 'communityId' must be defined.");
        url_ = url_.replace("{communityId}", encodeURIComponent("" + communityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForCommunity(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForCommunity(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForCommunity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForFormTemplate(formTemplateId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/form-template/{formTemplateId}/transitions";
        if (formTemplateId === undefined || formTemplateId === null)
            throw new Error("The parameter 'formTemplateId' must be defined.");
        url_ = url_.replace("{formTemplateId}", encodeURIComponent("" + formTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForFormTemplate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForFormTemplate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForFormTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForFormResponse(agreementId: number, formResponseId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses/{formResponseId}/transitions";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formResponseId === undefined || formResponseId === null)
            throw new Error("The parameter 'formResponseId' must be defined.");
        url_ = url_.replace("{formResponseId}", encodeURIComponent("" + formResponseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForFormResponse(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForFormResponse(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForFormResponse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForAgreement(agreementId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/transitions";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForAgreement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForReferenceFile(agreementId: number, referenceFileId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/reference-files/{referenceFileId}/transitions";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (referenceFileId === undefined || referenceFileId === null)
            throw new Error("The parameter 'referenceFileId' must be defined.");
        url_ = url_.replace("{referenceFileId}", encodeURIComponent("" + referenceFileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForReferenceFile(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForReferenceFile(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForReferenceFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForFormSchedule(agreementId: number, formScheduleId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-schedules/{formScheduleId}/transitions";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formScheduleId === undefined || formScheduleId === null)
            throw new Error("The parameter 'formScheduleId' must be defined.");
        url_ = url_.replace("{formScheduleId}", encodeURIComponent("" + formScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForFormSchedule(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForFormSchedule(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForFormSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForDocument(agreementId: number, documentId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/documents/{documentId}/transitions";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForDocument(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForDocument(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForClient(agreementId: number, clientId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/clients/{clientId}/transitions";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForClient(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForClient(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForClientExpense(agreementId: number, clientExpenseId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/client-expenses/{clientExpenseId}/transitions";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (clientExpenseId === undefined || clientExpenseId === null)
            throw new Error("The parameter 'clientExpenseId' must be defined.");
        url_ = url_.replace("{clientExpenseId}", encodeURIComponent("" + clientExpenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForClientExpense(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForClientExpense(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForClientExpense(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    setForDisbursement(agreementId: number, disbursementId: number, dto: TransitionRequestDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/disbursements/{disbursementId}/transitions";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (disbursementId === undefined || disbursementId === null)
            throw new Error("The parameter 'disbursementId' must be defined.");
        url_ = url_.replace("{disbursementId}", encodeURIComponent("" + disbursementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processSetForDisbursement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetForDisbursement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetForDisbursement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UploadsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: UploadCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/uploads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    downloadOne(uploadId: number, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/uploads/{uploadId}/download";
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDownloadOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDownloadOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadOne(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(uploadId: number, file?: FileParameter | null | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/uploads/{uploadId}";
        if (uploadId === undefined || uploadId === null)
            throw new Error("The parameter 'uploadId' must be defined.");
        url_ = url_.replace("{uploadId}", encodeURIComponent("" + uploadId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserPreferencesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    getMine(httpContext?: HttpContext): Observable<UserPreferencesDto> {
        let url_ = this.baseUrl + "/users/my/user-preferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMine(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMine(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPreferencesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPreferencesDto>;
        }));
    }

    protected processGetMine(response: HttpResponseBase): Observable<UserPreferencesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPreferencesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserRolesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOneForUser(userId: number, dto: UserRoleCreateDto, httpContext?: HttpContext): Observable<UserRoleCreatedResponseDto> {
        let url_ = this.baseUrl + "/users/{userId}/roles";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneForUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneForUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleCreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleCreatedResponseDto>;
        }));
    }

    protected processCreateOneForUser(response: HttpResponseBase): Observable<UserRoleCreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRoleCreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForUserAsDefault(userId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserRoleDto> {
        return this.getAllForUser(userId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfUserRoleDto>;
    }            
                
    getAllForUserAsMini(userId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserRoleMiniDto> {
        return this.getAllForUser(userId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfUserRoleMiniDto>;
    }            
                
    getAllForUserAsDetailed(userId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserRoleDetailedDto> {
        return this.getAllForUser(userId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfUserRoleDetailedDto>;
    }            
    
    

    private getAllForUser(userId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserRoleDto> {
        let url_ = this.baseUrl + "/users/{userId}/roles?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfUserRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfUserRoleDto>;
        }));
    }

    protected processGetAllForUser(response: HttpResponseBase): Observable<PagingOfUserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfUserRoleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(agencyId: number, userId: number, roleId: number, httpContext?: HttpContext): Observable<UserRoleDto> {
        return this.getOne(agencyId, userId, roleId, UnityViewType.Default, httpContext) as unknown as Observable<UserRoleDto>;
    }            
                
    getOneAsMini(agencyId: number, userId: number, roleId: number, httpContext?: HttpContext): Observable<UserRoleMiniDto> {
        return this.getOne(agencyId, userId, roleId, UnityViewType.Mini, httpContext) as unknown as Observable<UserRoleMiniDto>;
    }            
                
    getOneAsDetailed(agencyId: number, userId: number, roleId: number, httpContext?: HttpContext): Observable<UserRoleDetailedDto> {
        return this.getOne(agencyId, userId, roleId, UnityViewType.Detailed, httpContext) as unknown as Observable<UserRoleDetailedDto>;
    }            
    
    

    private getOne(agencyId: number, userId: number, roleId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<UserRoleDto> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/users/{userId}/roles/{roleId}?";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<UserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRoleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(agencyId: number, userId: number, roleId: number, dto: UserRoleUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/users/{userId}/roles/{roleId}";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: UserCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfUserDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfUserMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfUserDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserDto> {
        let url_ = this.baseUrl + "/users?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfUserDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllForRoleAsDefault(roleId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserDto> {
        return this.getAllForRole(roleId, UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfUserDto>;
    }            
                
    getAllForRoleAsMini(roleId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserMiniDto> {
        return this.getAllForRole(roleId, UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfUserMiniDto>;
    }            
                
    getAllForRoleAsDetailed(roleId: number, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserDetailedDto> {
        return this.getAllForRole(roleId, UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfUserDetailedDto>;
    }            
    
    

    private getAllForRole(roleId: number, viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfUserDto> {
        let url_ = this.baseUrl + "/roles/{roleId}/users?";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllForRole(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllForRole(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfUserDto>;
        }));
    }

    protected processGetAllForRole(response: HttpResponseBase): Observable<PagingOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(userId: number, httpContext?: HttpContext): Observable<UserDto> {
        return this.getOne(userId, UnityViewType.Default, httpContext) as unknown as Observable<UserDto>;
    }            
                
    getOneAsMini(userId: number, httpContext?: HttpContext): Observable<UserMiniDto> {
        return this.getOne(userId, UnityViewType.Mini, httpContext) as unknown as Observable<UserMiniDto>;
    }            
                
    getOneAsDetailed(userId: number, httpContext?: HttpContext): Observable<UserDetailedDto> {
        return this.getOne(userId, UnityViewType.Detailed, httpContext) as unknown as Observable<UserDetailedDto>;
    }            
    
    

    private getOne(userId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<UserDto> {
        let url_ = this.baseUrl + "/users/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(userId: number, dto: UserUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOne(userId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getMineAsDefault(httpContext?: HttpContext): Observable<UserDto> {
        return this.getMine(UnityViewType.Default, httpContext) as unknown as Observable<UserDto>;
    }            
                
    getMineAsMini(httpContext?: HttpContext): Observable<UserMiniDto> {
        return this.getMine(UnityViewType.Mini, httpContext) as unknown as Observable<UserMiniDto>;
    }            
                
    getMineAsDetailed(httpContext?: HttpContext): Observable<UserDetailedDto> {
        return this.getMine(UnityViewType.Detailed, httpContext) as unknown as Observable<UserDetailedDto>;
    }            
                
    getMineAsStats(httpContext?: HttpContext): Observable<UserStatsDto> {
        return this.getMine(UnityViewType.Stats, httpContext) as unknown as Observable<UserStatsDto>;
    }            
    
    

    private getMine(viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<UserDto> {
        let url_ = this.baseUrl + "/users/my?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMine(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMine(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetMine(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VendorsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: VendorCreateDto, httpContext?: HttpContext): Observable<CreatedResponseDto> {
        let url_ = this.baseUrl + "/vendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedResponseDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<CreatedResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfVendorDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfVendorDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfVendorMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfVendorMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfVendorDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfVendorDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfVendorDto> {
        let url_ = this.baseUrl + "/vendors?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfVendorDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfVendorDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(vendorId: number, httpContext?: HttpContext): Observable<VendorDto> {
        return this.getOne(vendorId, UnityViewType.Default, httpContext) as unknown as Observable<VendorDto>;
    }            
                
    getOneAsMini(vendorId: number, httpContext?: HttpContext): Observable<VendorMiniDto> {
        return this.getOne(vendorId, UnityViewType.Mini, httpContext) as unknown as Observable<VendorMiniDto>;
    }            
                
    getOneAsDetailed(vendorId: number, httpContext?: HttpContext): Observable<VendorDetailedDto> {
        return this.getOne(vendorId, UnityViewType.Detailed, httpContext) as unknown as Observable<VendorDetailedDto>;
    }            
    
    

    private getOne(vendorId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<VendorDto> {
        let url_ = this.baseUrl + "/vendors/{vendorId}?";
        if (vendorId === undefined || vendorId === null)
            throw new Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    updateOne(vendorId: number, dto: VendorUpdateDto, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/vendors/{vendorId}";
        if (vendorId === undefined || vendorId === null)
            throw new Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    deleteOne(vendorId: number, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/vendors/{vendorId}";
        if (vendorId === undefined || vendorId === null)
            throw new Error("The parameter 'vendorId' must be defined.");
        url_ = url_.replace("{vendorId}", encodeURIComponent("" + vendorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOne(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VendorTypesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfVendorTypeDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfVendorTypeDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfVendorTypeMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfVendorTypeMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfVendorTypeDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfVendorTypeDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfVendorTypeDto> {
        let url_ = this.baseUrl + "/vendor-types?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfVendorTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfVendorTypeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfVendorTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfVendorTypeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(formTypeId: number, httpContext?: HttpContext): Observable<VendorTypeDto> {
        return this.getOne(formTypeId, UnityViewType.Default, httpContext) as unknown as Observable<VendorTypeDto>;
    }            
                
    getOneAsMini(formTypeId: number, httpContext?: HttpContext): Observable<VendorTypeMiniDto> {
        return this.getOne(formTypeId, UnityViewType.Mini, httpContext) as unknown as Observable<VendorTypeMiniDto>;
    }            
                
    getOneAsDetailed(formTypeId: number, httpContext?: HttpContext): Observable<VendorTypeDetailedDto> {
        return this.getOne(formTypeId, UnityViewType.Detailed, httpContext) as unknown as Observable<VendorTypeDetailedDto>;
    }            
    
    

    private getOne(formTypeId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<VendorTypeDto> {
        let url_ = this.baseUrl + "/vendor-types/{formTypeId}?";
        if (formTypeId === undefined || formTypeId === null)
            throw new Error("The parameter 'formTypeId' must be defined.");
        url_ = url_.replace("{formTypeId}", encodeURIComponent("" + formTypeId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorTypeDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<VendorTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorTypeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WorkflowHistoriesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getForUserRoleAsDefault(agencyId: number, userId: number, roleId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        return this.getForUserRole(agencyId, userId, roleId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowHistoryDto[]>;
    }            
                
    getForUserRoleAsMini(agencyId: number, userId: number, roleId: number, httpContext?: HttpContext): Observable<WorkflowHistoryMiniDto[]> {
        return this.getForUserRole(agencyId, userId, roleId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowHistoryMiniDto[]>;
    }            
                
    getForUserRoleAsDetailed(agencyId: number, userId: number, roleId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDetailedDto[]> {
        return this.getForUserRole(agencyId, userId, roleId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowHistoryDetailedDto[]>;
    }            
    
    

    private getForUserRole(agencyId: number, userId: number, roleId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/users/{userId}/roles/{roleId}/workflow-histories?";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForUserRole(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForUserRole(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowHistoryDto[]>;
        }));
    }

    protected processGetForUserRole(response: HttpResponseBase): Observable<WorkflowHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getForAgencyAsDefault(agencyId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        return this.getForAgency(agencyId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowHistoryDto[]>;
    }            
                
    getForAgencyAsMini(agencyId: number, httpContext?: HttpContext): Observable<WorkflowHistoryMiniDto[]> {
        return this.getForAgency(agencyId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowHistoryMiniDto[]>;
    }            
                
    getForAgencyAsDetailed(agencyId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDetailedDto[]> {
        return this.getForAgency(agencyId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowHistoryDetailedDto[]>;
    }            
    
    

    private getForAgency(agencyId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        let url_ = this.baseUrl + "/agencies/{agencyId}/workflow-histories?";
        if (agencyId === undefined || agencyId === null)
            throw new Error("The parameter 'agencyId' must be defined.");
        url_ = url_.replace("{agencyId}", encodeURIComponent("" + agencyId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForAgency(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForAgency(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowHistoryDto[]>;
        }));
    }

    protected processGetForAgency(response: HttpResponseBase): Observable<WorkflowHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getForUserAsDefault(userId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        return this.getForUser(userId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowHistoryDto[]>;
    }            
                
    getForUserAsMini(userId: number, httpContext?: HttpContext): Observable<WorkflowHistoryMiniDto[]> {
        return this.getForUser(userId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowHistoryMiniDto[]>;
    }            
                
    getForUserAsDetailed(userId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDetailedDto[]> {
        return this.getForUser(userId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowHistoryDetailedDto[]>;
    }            
    
    

    private getForUser(userId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        let url_ = this.baseUrl + "/users/{userId}/workflow-histories?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowHistoryDto[]>;
        }));
    }

    protected processGetForUser(response: HttpResponseBase): Observable<WorkflowHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getForProgramAsDefault(programId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        return this.getForProgram(programId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowHistoryDto[]>;
    }            
                
    getForProgramAsMini(programId: number, httpContext?: HttpContext): Observable<WorkflowHistoryMiniDto[]> {
        return this.getForProgram(programId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowHistoryMiniDto[]>;
    }            
                
    getForProgramAsDetailed(programId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDetailedDto[]> {
        return this.getForProgram(programId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowHistoryDetailedDto[]>;
    }            
    
    

    private getForProgram(programId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        let url_ = this.baseUrl + "/programs/{programId}/workflow-histories?";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined.");
        url_ = url_.replace("{programId}", encodeURIComponent("" + programId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForProgram(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForProgram(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowHistoryDto[]>;
        }));
    }

    protected processGetForProgram(response: HttpResponseBase): Observable<WorkflowHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getForFormResponseAsDefault(agreementId: number, formResponseId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        return this.getForFormResponse(agreementId, formResponseId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowHistoryDto[]>;
    }            
                
    getForFormResponseAsMini(agreementId: number, formResponseId: number, httpContext?: HttpContext): Observable<WorkflowHistoryMiniDto[]> {
        return this.getForFormResponse(agreementId, formResponseId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowHistoryMiniDto[]>;
    }            
                
    getForFormResponseAsDetailed(agreementId: number, formResponseId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDetailedDto[]> {
        return this.getForFormResponse(agreementId, formResponseId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowHistoryDetailedDto[]>;
    }            
    
    

    private getForFormResponse(agreementId: number, formResponseId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-responses/{formResponseId}/workflow-histories?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formResponseId === undefined || formResponseId === null)
            throw new Error("The parameter 'formResponseId' must be defined.");
        url_ = url_.replace("{formResponseId}", encodeURIComponent("" + formResponseId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForFormResponse(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForFormResponse(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowHistoryDto[]>;
        }));
    }

    protected processGetForFormResponse(response: HttpResponseBase): Observable<WorkflowHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getForAgreementAsDefault(agreementId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        return this.getForAgreement(agreementId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowHistoryDto[]>;
    }            
                
    getForAgreementAsMini(agreementId: number, httpContext?: HttpContext): Observable<WorkflowHistoryMiniDto[]> {
        return this.getForAgreement(agreementId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowHistoryMiniDto[]>;
    }            
                
    getForAgreementAsDetailed(agreementId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDetailedDto[]> {
        return this.getForAgreement(agreementId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowHistoryDetailedDto[]>;
    }            
    
    

    private getForAgreement(agreementId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/workflow-histories?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowHistoryDto[]>;
        }));
    }

    protected processGetForAgreement(response: HttpResponseBase): Observable<WorkflowHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getForReferenceFileAsDefault(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        return this.getForReferenceFile(agreementId, referenceFileId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowHistoryDto[]>;
    }            
                
    getForReferenceFileAsMini(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<WorkflowHistoryMiniDto[]> {
        return this.getForReferenceFile(agreementId, referenceFileId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowHistoryMiniDto[]>;
    }            
                
    getForReferenceFileAsDetailed(agreementId: number, referenceFileId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDetailedDto[]> {
        return this.getForReferenceFile(agreementId, referenceFileId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowHistoryDetailedDto[]>;
    }            
    
    

    private getForReferenceFile(agreementId: number, referenceFileId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/reference-files/{referenceFileId}/workflow-histories?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (referenceFileId === undefined || referenceFileId === null)
            throw new Error("The parameter 'referenceFileId' must be defined.");
        url_ = url_.replace("{referenceFileId}", encodeURIComponent("" + referenceFileId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForReferenceFile(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForReferenceFile(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowHistoryDto[]>;
        }));
    }

    protected processGetForReferenceFile(response: HttpResponseBase): Observable<WorkflowHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getForFormScheduleAsDefault(agreementId: number, formScheduleId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        return this.getForFormSchedule(agreementId, formScheduleId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowHistoryDto[]>;
    }            
                
    getForFormScheduleAsMini(agreementId: number, formScheduleId: number, httpContext?: HttpContext): Observable<WorkflowHistoryMiniDto[]> {
        return this.getForFormSchedule(agreementId, formScheduleId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowHistoryMiniDto[]>;
    }            
                
    getForFormScheduleAsDetailed(agreementId: number, formScheduleId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDetailedDto[]> {
        return this.getForFormSchedule(agreementId, formScheduleId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowHistoryDetailedDto[]>;
    }            
    
    

    private getForFormSchedule(agreementId: number, formScheduleId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/form-schedules/{formScheduleId}/workflow-histories?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (formScheduleId === undefined || formScheduleId === null)
            throw new Error("The parameter 'formScheduleId' must be defined.");
        url_ = url_.replace("{formScheduleId}", encodeURIComponent("" + formScheduleId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForFormSchedule(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForFormSchedule(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowHistoryDto[]>;
        }));
    }

    protected processGetForFormSchedule(response: HttpResponseBase): Observable<WorkflowHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getForDocumentAsDefault(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        return this.getForDocument(agreementId, documentId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowHistoryDto[]>;
    }            
                
    getForDocumentAsMini(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<WorkflowHistoryMiniDto[]> {
        return this.getForDocument(agreementId, documentId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowHistoryMiniDto[]>;
    }            
                
    getForDocumentAsDetailed(agreementId: number, documentId: number, httpContext?: HttpContext): Observable<WorkflowHistoryDetailedDto[]> {
        return this.getForDocument(agreementId, documentId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowHistoryDetailedDto[]>;
    }            
    
    

    private getForDocument(agreementId: number, documentId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowHistoryDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/documents/{documentId}/workflow-histories?";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetForDocument(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetForDocument(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowHistoryDto[]>;
        }));
    }

    protected processGetForDocument(response: HttpResponseBase): Observable<WorkflowHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WorkflowsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getAllAsDefault(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfWorkflowDto> {
        return this.getAll(UnityViewType.Default, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfWorkflowDto>;
    }            
                
    getAllAsMini(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfWorkflowMiniDto> {
        return this.getAll(UnityViewType.Mini, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfWorkflowMiniDto>;
    }            
                
    getAllAsDetailed(gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfWorkflowDetailedDto> {
        return this.getAll(UnityViewType.Detailed, gridifyQuery_Page, gridifyQuery_PageSize, gridifyQuery_OrderBy, gridifyQuery_Filter, httpContext) as unknown as Observable<PagingOfWorkflowDetailedDto>;
    }            
    
    

    private getAll(viewType?: UnityViewType | undefined, gridifyQuery_Page?: number | undefined, gridifyQuery_PageSize?: number | undefined, gridifyQuery_OrderBy?: string | null | undefined, gridifyQuery_Filter?: string | null | undefined, httpContext?: HttpContext): Observable<PagingOfWorkflowDto> {
        let url_ = this.baseUrl + "/workflows?";
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        if (gridifyQuery_Page === null)
            throw new Error("The parameter 'gridifyQuery_Page' cannot be null.");
        else if (gridifyQuery_Page !== undefined)
            url_ += "GridifyQuery.Page=" + encodeURIComponent("" + gridifyQuery_Page) + "&";
        if (gridifyQuery_PageSize === null)
            throw new Error("The parameter 'gridifyQuery_PageSize' cannot be null.");
        else if (gridifyQuery_PageSize !== undefined)
            url_ += "GridifyQuery.PageSize=" + encodeURIComponent("" + gridifyQuery_PageSize) + "&";
        if (gridifyQuery_OrderBy !== undefined && gridifyQuery_OrderBy !== null)
            url_ += "GridifyQuery.OrderBy=" + encodeURIComponent("" + gridifyQuery_OrderBy) + "&";
        if (gridifyQuery_Filter !== undefined && gridifyQuery_Filter !== null)
            url_ += "GridifyQuery.Filter=" + encodeURIComponent("" + gridifyQuery_Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAll(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingOfWorkflowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingOfWorkflowDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagingOfWorkflowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingOfWorkflowDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    
    
    
    
    
    
    
    
    
    
    
    
                
    getOneAsDefault(workflowId: number, httpContext?: HttpContext): Observable<WorkflowDto> {
        return this.getOne(workflowId, UnityViewType.Default, httpContext) as unknown as Observable<WorkflowDto>;
    }            
                
    getOneAsMini(workflowId: number, httpContext?: HttpContext): Observable<WorkflowMiniDto> {
        return this.getOne(workflowId, UnityViewType.Mini, httpContext) as unknown as Observable<WorkflowMiniDto>;
    }            
                
    getOneAsDetailed(workflowId: number, httpContext?: HttpContext): Observable<WorkflowDetailedDto> {
        return this.getOne(workflowId, UnityViewType.Detailed, httpContext) as unknown as Observable<WorkflowDetailedDto>;
    }            
    
    

    private getOne(workflowId: number, viewType?: UnityViewType | undefined, httpContext?: HttpContext): Observable<WorkflowDto> {
        let url_ = this.baseUrl + "/workflows/{workflowId}?";
        if (workflowId === undefined || workflowId === null)
            throw new Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        if (viewType === null)
            throw new Error("The parameter 'viewType' cannot be null.");
        else if (viewType !== undefined)
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<WorkflowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WorkItemsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    getAllMineForAgreement(agreementId: number, httpContext?: HttpContext): Observable<WorkItemDto[]> {
        let url_ = this.baseUrl + "/agreements/{agreementId}/work-items";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllMineForAgreement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllMineForAgreement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkItemDto[]>;
        }));
    }

    protected processGetAllMineForAgreement(response: HttpResponseBase): Observable<WorkItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkItemDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicUsersClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    confirmOne(userGuid: string, dto: UserConfirmationDto, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/public/identity/users/{userGuid}";
        if (userGuid === undefined || userGuid === null)
            throw new Error("The parameter 'userGuid' must be defined.");
        url_ = url_.replace("{userGuid}", encodeURIComponent("" + userGuid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processConfirmOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processConfirmOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmOne(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityIdentityProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    createOneConfirmationEmail(dto: ResendUserConfirmationDto, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/public/identity/users/resend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneConfirmationEmail(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneConfirmationEmail(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateOneConfirmationEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityIdentityProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FlowsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    getOne(username?: string | undefined, httpContext?: HttpContext): Observable<AuthFlowResponseDto> {
        let url_ = this.baseUrl + "/auth/flows?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthFlowResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthFlowResponseDto>;
        }));
    }

    protected processGetOne(response: HttpResponseBase): Observable<AuthFlowResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthFlowResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ImpersonationsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: ImpersonationCreateDto, httpContext?: HttpContext): Observable<AuthSessionDto> {
        let url_ = this.baseUrl + "/auth/impersonations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSessionDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<AuthSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthSessionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MfaUrlsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(dto: AuthCredentialExchangeDto, httpContext?: HttpContext): Observable<StsAcgUrlResponse> {
        let url_ = this.baseUrl + "/auth/mfa-urls";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StsAcgUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StsAcgUrlResponse>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<StsAcgUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StsAcgUrlResponse;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityIdentityProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PasswordResetsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOne(request: PasswordResetRequest, httpContext?: HttpContext): Observable<PasswordResetDto> {
        let url_ = this.baseUrl + "/auth/password-resets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOne(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PasswordResetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PasswordResetDto>;
        }));
    }

    protected processCreateOne(response: HttpResponseBase): Observable<PasswordResetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PasswordResetDto;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityIdentityProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SessionsClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    

    createOneAcgSession(dto: AuthMfaCodeExchangeDto, httpContext?: HttpContext): Observable<AuthSessionDto> {
        let url_ = this.baseUrl + "/auth/acg/sessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneAcgSession(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneAcgSession(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSessionDto>;
        }));
    }

    protected processCreateOneAcgSession(response: HttpResponseBase): Observable<AuthSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthSessionDto;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityIdentityProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    createOneRopgSession(dto: AuthCredentialExchangeDto, httpContext?: HttpContext): Observable<AuthSessionDto> {
        let url_ = this.baseUrl + "/auth/ropg/sessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOneRopgSession(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOneRopgSession(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSessionDto>;
        }));
    }

    protected processCreateOneRopgSession(response: HttpResponseBase): Observable<AuthSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedResponseDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthSessionDto;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityIdentityProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    

    refreshSession(httpContext?: HttpContext): Observable<AuthSessionDto> {
        let url_ = this.baseUrl + "/auth/sessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: httpContext,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.transformResult(url_, response_, (r) => this.processRefreshSession(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRefreshSession(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSessionDto>;
        }));
    }

    protected processRefreshSession(response: HttpResponseBase): Observable<AuthSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityValidationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthenticationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityAuthorizationProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityNotFoundProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnityInternalProblem;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthSessionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface CreatedResponseDto {
    id: number;
}

export interface AUnityProblem {
    type: string;
    status?: number | null;
    detail: string;
    exception: string;
    instance: string;
    stack_trace?: string[] | null;
    data?: any | null;
    inner?: UnityInternalProblem | null;
    title: string;
}

export interface UnityValidationProblem extends AUnityProblem {
    errors?: { [key: string]: UnityValidationError[]; };
}

export function isUnityValidationProblem(object: any): object is UnityValidationProblem {
    return object && object['title'] === 'UnityValidationProblem';
}

export interface UnityValidationError {
    message: string;
    code: UnityErrorType;
}

export enum UnityErrorType {
    EmailValidator = "EmailValidator",
    GreaterThanOrEqualValidator = "GreaterThanOrEqualValidator",
    GreaterThanValidator = "GreaterThanValidator",
    LengthValidator = "LengthValidator",
    MinimumLengthValidator = "MinimumLengthValidator",
    MaximumLengthValidator = "MaximumLengthValidator",
    LessThanOrEqualValidator = "LessThanOrEqualValidator",
    LessThanValidator = "LessThanValidator",
    NotEmptyValidator = "NotEmptyValidator",
    NotEqualValidator = "NotEqualValidator",
    NotNullValidator = "NotNullValidator",
    PredicateValidator = "PredicateValidator",
    AsyncPredicateValidator = "AsyncPredicateValidator",
    RegularExpressionValidator = "RegularExpressionValidator",
    EqualValidator = "EqualValidator",
    ExactLengthValidator = "ExactLengthValidator",
    InclusiveBetweenValidator = "InclusiveBetweenValidator",
    ExclusiveBetweenValidator = "ExclusiveBetweenValidator",
    CreditCardValidator = "CreditCardValidator",
    ScalePrecisionValidator = "ScalePrecisionValidator",
    EmptyValidator = "EmptyValidator",
    NullValidator = "NullValidator",
    EnumValidator = "EnumValidator",
    Length_Simple = "Length_Simple",
    MinimumLength_Simple = "MinimumLength_Simple",
    MaximumLength_Simple = "MaximumLength_Simple",
    ExactLength_Simple = "ExactLength_Simple",
    InclusiveBetween_Simple = "InclusiveBetween_Simple",
    UniquenessValidator = "UniquenessValidator",
    PhoneValidator = "PhoneValidator",
    ExistanceValidator = "ExistanceValidator",
    AmendRootValidator = "AmendRootValidator",
    RequiredValidator = "RequiredValidator",
    RecurrencePatternValidator = "RecurrencePatternValidator",
    AhfcEmailValidator = "AhfcEmailValidator",
    InternalAgencyValidator = "InternalAgencyValidator",
    RoleAgencyValidator = "RoleAgencyValidator",
    FileExtensionValidator = "FileExtensionValidator",
    ExternalEmailValidator = "ExternalEmailValidator",
    ExternalAgencyValidator = "ExternalAgencyValidator",
    AhfcUserNameValidator = "AhfcUserNameValidator",
    FormResponseSubmitValidator = "FormResponseSubmitValidator",
    SurveyJsValidator = "SurveyJsValidator",
    InvalidTransitionValidator = "InvalidTransitionValidator",
    UnsupportedFeatureValidator = "UnsupportedFeatureValidator",
    Unknown = "Unknown",
}

export interface UnityInternalProblem extends AUnityProblem {
}

export function isUnityInternalProblem(object: any): object is UnityInternalProblem {
    return object && object['title'] === 'UnityInternalProblem';
}

export interface UnityNotFoundProblem extends AUnityProblem {
}

export function isUnityNotFoundProblem(object: any): object is UnityNotFoundProblem {
    return object && object['title'] === 'UnityNotFoundProblem';
}

export interface UnityAuthorizationProblem extends AUnityProblem {
}

export function isUnityAuthorizationProblem(object: any): object is UnityAuthorizationProblem {
    return object && object['title'] === 'UnityAuthorizationProblem';
}

export interface UnityAuthenticationProblem extends AUnityProblem {
}

export function isUnityAuthenticationProblem(object: any): object is UnityAuthenticationProblem {
    return object && object['title'] === 'UnityAuthenticationProblem';
}

export interface UnityIdentityProblem extends AUnityProblem {
    error_code?: AhfcIdentityErrorCodes;
}

export function isUnityIdentityProblem(object: any): object is UnityIdentityProblem {
    return object && object['title'] === 'UnityIdentityProblem';
}

export enum AhfcIdentityErrorCodes {
    EmailNotConfirmed = 0,
    EmailConfirmed = 1,
    UserInvalid = 2,
    UserInvalidToken = 3,
    UserArchived = 4,
    UserImmutable = 5,
    UserInvalidPassword = 6,
    Unknown = 7,
}

export interface AgencyCreateDto {
    name: string;
    contact: string;
    phone: string;
    email: string;
    community_ids: number[];
    code: string;
}

export interface PagingOfAgencyDetailedDto {
    count: number;
    data: AgencyDetailedDto[];
}

export interface AgencyDetailedDto {
    id: number;
    name: string;
    contact: string;
    phone: string;
    email: string;
    communities: CommunityMiniDto[];
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
    code: string;
    agreements_count: number;
    total_award_amount: number;
    total_disbursed_amount: number;
    is_internal: boolean;
}

export interface CommunityMiniDto {
    id: number;
    name: string;
    community_area_name?: string | null;
    is_statewide: boolean;
    is_active: boolean;
}

export interface UserMiniDto {
    id: number;
    user_name: string;
    full_name: string;
    is_internal: boolean;
}

export interface WorkflowStateMiniDto {
    id: number;
    name: string;
    is_editable: boolean;
    enum_value: UnityWorkflowState;
}

export enum UnityWorkflowState {
    Active = "Active",
    Approved = "Approved",
    Archived = "Archived",
    Canceled = "Canceled",
    ChangeRequested = "ChangeRequested",
    Completed = "Completed",
    Disabled = "Disabled",
    Draft = "Draft",
    Duplicate = "Duplicate",
    Exited = "Exited",
    Paid = "Paid",
    PendingApproval = "PendingApproval",
    PendingDirectorApproval = "PendingDirectorApproval",
    Planned = "Planned",
    Refunded = "Refunded",
    Rejected = "Rejected",
    Unknown = "Unknown",
}

export enum UnityViewType {
    Default = "Default",
    Detailed = "Detailed",
    Mini = "Mini",
    Stats = "Stats",
}

export interface PagingOfAgencyDto {
    count: number;
    data: AgencyDto[];
}

export interface AgencyDto {
    id: number;
    name: string;
    contact: string;
    phone: string;
    email: string;
    community_ids: number[];
    current_state_id: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    code: string;
    agreements_count: number;
    total_award_amount: number;
    total_disbursed_amount: number;
    is_internal: boolean;
}

export interface PagingOfAgencyMiniDto {
    count: number;
    data: AgencyMiniDto[];
}

export interface AgencyMiniDto {
    id: number;
    name: string;
    image_url: string;
    code: string;
    is_internal: boolean;
}

export interface AgencyUpdateDto {
    name: string;
    contact: string;
    phone: string;
    email: string;
    code: string;
}

export interface PagingOfAgencyUserDetailedDto {
    count: number;
    data: AgencyUserDetailedDto[];
}

export interface AgencyUserDetailedDto {
    id: number;
    user_name: string;
    full_name: string;
    agency: AgencyMiniDto;
    current_state: WorkflowStateMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    role: RoleMiniDto;
}

export interface RoleMiniDto {
    id: number;
    name: string;
    description: string;
    agency_id: number;
}

export interface PagingOfAgencyUserDto {
    count: number;
    data: AgencyUserDto[];
}

export interface AgencyUserDto {
    id: number;
    agency_id: number;
    user_name: string;
    full_name: string;
    current_state_name: string;
    current_state_id: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    role_id: number;
}

export interface PagingOfAgencyUserMiniDto {
    count: number;
    data: AgencyUserMiniDto[];
}

export interface AgencyUserMiniDto {
    id: number;
    agency_id: number;
    user_name: string;
    full_name: string;
}

export interface AgreementCreateDto {
    name: string;
    description?: string | null;
    award_amount?: number | null;
    agreement_date: Date;
    start_date: Date;
    end_date: Date;
    community_ids: number[];
    agency_id: number;
    program_id: number;
    client_share_of_award_amount?: number | null;
    client_standard_allocation_amount?: number | null;
    client_form_schema_id?: number | null;
    client_expense_form_schema_id?: number | null;
    disbursement_form_schema_id?: number | null;
    supports_clients: boolean;
    supports_client_expenses: boolean;
    supports_disbursements: boolean;
    supports_documents: boolean;
    supports_forms: boolean;
    supports_reference_files: boolean;
}

export interface PagingOfAgreementDetailedDto {
    count: number;
    data: AgreementDetailedDto[];
}

export interface FilteredOfAgreementDetailedDto extends PagingOfAgreementDetailedDto {
    total?: number;
}

export function isFilteredOfAgreementDetailedDto(object: any): object is FilteredOfAgreementDetailedDto {
    return object && object[''] === 'FilteredOfAgreementDetailedDto';
}

export interface AgreementDetailedDto {
    id: number;
    name: string;
    description?: string | null;
    award_amount?: number | null;
    supports_clients: boolean;
    supports_client_expenses: boolean;
    supports_disbursements: boolean;
    supports_documents: boolean;
    supports_forms: boolean;
    supports_reference_files: boolean;
    client_share_of_award_amount?: number | null;
    client_standard_allocation_amount?: number | null;
    is_mine: boolean;
    percent_disbursed?: number | null;
    agreement_date: Date;
    start_date: Date;
    end_date: Date;
    communities: CommunityMiniDto[];
    agency: AgencyMiniDto;
    program: ProgramMiniDto;
    is_overdue: boolean;
    year: number;
    fiscal_year: number;
    state_fiscal_year: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
    client_form_schema?: FormSchemaMiniDto | null;
    client_expense_form_schema?: FormSchemaMiniDto | null;
    disbursement_form_schema?: FormSchemaMiniDto | null;
    total_disbursement_amount: number;
}

export interface ProgramMiniDto {
    id: number;
    code: string;
    name: string;
}

export interface FormSchemaMiniDto {
    id: number;
    name: string;
    type_id: number;
    default_workflow_id: number;
    type_enum_value: UnityFormType;
    current_state_active_state: boolean;
    current_state_name: string;
}

export enum UnityFormType {
    Unknown = "Unknown",
    Client = "Client",
    ClientExpense = "ClientExpense",
    Disbursement = "Disbursement",
    Form = "Form",
}

export interface PagingOfAgreementDto {
    count: number;
    data: AgreementDto[];
}

export interface AgreementDto {
    id: number;
    name: string;
    description?: string | null;
    award_amount?: number | null;
    supports_clients: boolean;
    supports_client_expenses: boolean;
    supports_disbursements: boolean;
    supports_documents: boolean;
    supports_forms: boolean;
    supports_reference_files: boolean;
    client_share_of_award_amount?: number | null;
    client_standard_allocation_amount?: number | null;
    agreement_date: Date;
    start_date: Date;
    end_date: Date;
    community_ids: number[];
    agency_id: number;
    program_id: number;
    program_name: string;
    total_disbursement_amount: number;
    remaining_award_amount?: number | null;
    current_state_id: number;
    is_overdue: boolean;
    year: number;
    fiscal_year: number;
    state_fiscal_year: number;
    form_types: FormTypeMiniDto[];
    client_form_schema_id?: number | null;
    client_expense_form_schema_id?: number | null;
    disbursement_form_schema_id?: number | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    remaining_client_slots: number;
    remaining_client_expensed_amount: number;
}

export interface FormTypeMiniDto {
    id: number;
    name: string;
    enum_value: UnityFormType;
    is_deletable: boolean;
}

export interface PagingOfAgreementMiniDto {
    count: number;
    data: AgreementMiniDto[];
}

export interface AgreementMiniDto {
    id: number;
    name: string;
    description?: string | null;
    award_amount?: number | null;
    supports_clients: boolean;
    supports_client_expenses: boolean;
    supports_disbursements: boolean;
    supports_documents: boolean;
    supports_forms: boolean;
    supports_reference_files: boolean;
    client_share_of_award_amount?: number | null;
    client_standard_allocation_amount?: number | null;
    agency_id: number;
    program_id: number;
    last_modified_dt: Date;
}

export interface AgreementStatsDto {
    id: number;
    overdue_form_count: number;
    total_active_clients: number;
    total_client_expenses_count: number;
    award_amount?: number | null;
    approved_disbursement_amount: number;
    pending_disbursement_amount: number;
    total_disbursement_amount: number;
    remaining_award_amount?: number | null;
    client_share_of_award_amount?: number | null;
    total_client_allocated_amount: number;
    remaining_client_allocation_amount: number;
    remaining_client_expensed_amount: number;
    total_client_expensed_amount: number;
}

export interface AgreementUpdateDto {
    name: string;
    description?: string | null;
    award_amount?: number | null;
    client_share_of_award_amount?: number | null;
    client_standard_allocation_amount?: number | null;
    agreement_date: Date;
    start_date: Date;
    end_date: Date;
}

export interface AgreementUserCreateDto {
    user_id: number;
    agency_id: number;
    agreement_id: number;
}

export interface PagingOfAgreementUserDetailedDto {
    count: number;
    data: AgreementUserDetailedDto[];
}

export interface AgreementUserDetailedDto {
    id: number;
    user_name: string;
    full_name: string;
    is_internal: boolean;
    user_role_id: number;
    user_role_name: string;
    role_status: UnityWorkflowState;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export interface PagingOfAgreementUserDto {
    count: number;
    data: AgreementUserDto[];
}

export interface AgreementUserDto {
    id: number;
    user_name: string;
    full_name: string;
    is_internal: boolean;
    user_role_id: number;
    user_role_name: string;
    role_status: UnityWorkflowState;
}

export interface PagingOfAgreementUserMiniDto {
    count: number;
    data: AgreementUserMiniDto[];
}

export interface AgreementUserMiniDto {
    id: number;
    user_name: string;
    full_name: string;
    is_internal: boolean;
    user_role_id: number;
    user_role_name: string;
    role_status: UnityWorkflowState;
}

export interface TransitionDetailedDto {
    id: number;
    name: string;
    from_state: WorkflowStateMiniDto;
    to_state: WorkflowStateMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    is_comment_required: boolean;
    requires_validation: boolean;
    is_initial: boolean;
}

export interface TransitionDto {
    id: number;
    name: string;
    from_state_id: number;
    from_state_name: string;
    to_state_id: number;
    to_state_name: string;
    is_comment_required: boolean;
    requires_validation: boolean;
    is_initial: boolean;
}

export interface TransitionMiniDto {
    id: number;
    name: string;
    from_state_id: number;
    from_state_name: string;
    to_state_id: number;
    to_state_name: string;
    to_state_enum_value: UnityWorkflowState;
    is_comment_required: boolean;
    requires_validation: boolean;
    is_initial: boolean;
    is_date_overrideable: boolean;
}

export interface ClientExpenseCreateDto {
    agreement_id: number;
    initial_transition_id: number;
    client_id: number;
    vendor_id?: number | null;
    amount?: number | null;
    date?: Date | null;

    [key: string]: any;
}

export interface ClientExpenseDetailedDto {
    id: number;
    reference_number_display: string;
    agreement: AgreementMiniDto;
    form_schema: FormSchemaMiniDto;
    current_state: WorkflowStateMiniDto;
    version_id: number;
    client: ClientMiniDto;
    client_id: number;
    vendor?: VendorMiniDto | null;
    amount?: number | null;
    date?: Date | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;

    [key: string]: any;
}

export interface ClientMiniDto {
    id: number;
    reference_number_display: string;
    agreement_id: number;
    version_id: number;
    first_name?: string | null;
    last_name?: string | null;
}

export interface VendorMiniDto {
    id: number;
    name: string;
    type_enum_value: UnityVendorType;
    tin: string;
    w9_upload_id?: number;
}

export enum UnityVendorType {
    Unknown = "Unknown",
    Business = "Business",
    Landlord = "Landlord",
}

export interface ClientExpenseDto {
    id: number;
    reference_number_display: string;
    agreement_id: number;
    client_id: number;
    workflow_id: number;
    current_state_id: number;
    form_schema_id: number;
    version_id: number;
    vendor_id?: number | null;
    amount?: number | null;
    date?: Date | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;

    [key: string]: any;
}

export interface ClientExpenseMiniDto {
    id: number;
    reference_number_display: string;
    agreement_id: number;
    version_id: number;
    client_id: number;
}

export interface PagingOfClientExpenseDetailedDto {
    count: number;
    data: ClientExpenseDetailedDto[];
}

export interface PagingOfClientExpenseDto {
    count: number;
    data: ClientExpenseDto[];
}

export interface PagingOfClientExpenseMiniDto {
    count: number;
    data: ClientExpenseMiniDto[];
}

export interface ClientExpenseUpdateDto {
    transition_id?: number | null;
    vendor_id?: number | null;
    amount?: number | null;
    date?: Date | null;

    [key: string]: any;
}

export interface ClientCreateDto {
    agreement_id: number;
    initial_transition_id: number;
    first_name?: string | null;
    middle_name?: string | null;
    last_name?: string | null;
    birth_date?: Date | null;
    allocated_amount?: number | null;

    [key: string]: any;
}

export interface ClientDetailedDto {
    id: number;
    reference_number_display: string;
    agreement: AgreementMiniDto;
    form_schema: FormSchemaMiniDto;
    current_state: WorkflowStateMiniDto;
    version_id: number;
    first_name?: string | null;
    middle_name?: string | null;
    last_name?: string | null;
    birth_date?: Date | null;
    allocated_amount: number;
    total_expensed_amount: number;
    remaining_allocated_amount: number;
    start_date: Date;
    end_date?: Date | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;

    [key: string]: any;
}

export interface ClientDto {
    id: number;
    reference_number_display: string;
    agreement_id: number;
    current_state_id: number;
    form_schema_id: number;
    version_id: number;
    first_name?: string | null;
    middle_name?: string | null;
    last_name?: string | null;
    birth_date?: Date | null;
    allocated_amount: number;
    start_date: Date;
    end_date?: Date | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    total_expensed_amount: number;
    remaining_allocated_amount: number;

    [key: string]: any;
}

export interface PagingOfClientDetailedDto {
    count: number;
    data: ClientDetailedDto[];
}

export interface PagingOfClientDto {
    count: number;
    data: ClientDto[];
}

export interface PagingOfClientMiniDto {
    count: number;
    data: ClientMiniDto[];
}

export interface ClientUpdateDto {
    first_name?: string | null;
    middle_name?: string | null;
    last_name?: string | null;
    birth_date?: Date | null;
    allocated_amount?: number | null;
    transition_id?: number | null;

    [key: string]: any;
}

export interface CommunityCreateDto {
    name: string;
    area_name?: string | null;
}

export interface PagingOfCommunityDetailedDto {
    count: number;
    data: CommunityDetailedDto[];
}

export interface CommunityDetailedDto {
    id: number;
    name: string;
    is_statewide: boolean;
    community_area_name?: string | null;
    is_active: boolean;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
}

export interface PagingOfCommunityDto {
    count: number;
    data: CommunityDto[];
}

export interface CommunityDto {
    id: number;
    name: string;
    is_statewide: boolean;
    community_area_name?: string | null;
    is_active: boolean;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    current_state_id: number;
}

export interface PagingOfCommunityMiniDto {
    count: number;
    data: CommunityMiniDto[];
}

export interface CommunityUpdateDto {
    name: string;
    area_name?: string | null;
}

export interface DisbursementCreateDto {
    agreement_id: number;
    initial_transition_id: number;
    amount?: number | null;
    date?: Date | null;

    [key: string]: any;
}

export interface DisbursementDetailedDto {
    id: number;
    reference_number_display: string;
    workflow_id: number;
    agreement: AgreementMiniDto;
    form_schema: FormSchemaMiniDto;
    current_state: WorkflowStateMiniDto;
    version_id: number;
    amount?: number | null;
    date?: Date | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;

    [key: string]: any;
}

export interface DisbursementDto {
    id: number;
    reference_number_display: string;
    agreement_id: number;
    current_state_id: number;
    form_schema_id: number;
    version_id: number;
    amount?: number | null;
    date?: Date | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;

    [key: string]: any;
}

export interface DisbursementMiniDto {
    id: number;
    reference_number_display: string;
    agreement_id: number;
    version_id: number;
}

export interface PagingOfDisbursementDetailedDto {
    count: number;
    data: DisbursementDetailedDto[];
}

export interface PagingOfDisbursementDto {
    count: number;
    data: DisbursementDto[];
}

export interface PagingOfDisbursementMiniDto {
    count: number;
    data: DisbursementMiniDto[];
}

export interface DisbursementUpdateDto {
    amount?: number | null;
    date?: Date | null;
    transition_id?: number | null;

    [key: string]: any;
}

export interface DocumentCreateDto {
    name: string;
    description: string;
    agreement_id: number;
    parent_document_id?: number | null;
    upload_id: number;
}

export interface PagingOfDocumentDetailedDto {
    count: number;
    data: DocumentDetailedDto[];
}

export interface DocumentDetailedDto {
    id: number;
    name: string;
    description: string;
    agreement: AgreementMiniDto;
    parent_document?: DocumentMiniDto | null;
    upload: UploadMiniDto;
    current_state: WorkflowStateMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export interface DocumentMiniDto {
    id: number;
    name: string;
    upload_id: number;
    current_state_id: number;
}

export interface UploadMiniDto {
    id: number;
    file_name: string;
    file_type: string;
    file_size: number;
}

export interface PagingOfDocumentDto {
    count: number;
    data: DocumentDto[];
}

export interface DocumentDto {
    id: number;
    name: string;
    description: string;
    agreement_id: number;
    parent_document_id?: number | null;
    upload_id: number;
    current_state_id: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
}

export interface PagingOfDocumentMiniDto {
    count: number;
    data: DocumentMiniDto[];
}

export interface DocumentUpdateDto {
    name: string;
    description: string;
}

export interface PagingOfEntitlementDetailedDto {
    count: number;
    data: EntitlementDetailedDto[];
}

export interface EntitlementDetailedDto {
    id: number;
    name: string;
    enum_value: UnityEntitlement;
    description: string;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export enum UnityEntitlement {
    Unknown = "Unknown",
    Agency = "Agency",
    AgencyUser = "AgencyUser",
    Agreement = "Agreement",
    Client = "Client",
    ClientExpense = "ClientExpense",
    Community = "Community",
    Disbursement = "Disbursement",
    Document = "Document",
    Entitlement = "Entitlement",
    FormInstance = "FormInstance",
    FormResponse = "FormResponse",
    FormSchedule = "FormSchedule",
    FormSchema = "FormSchema",
    Impersonation = "Impersonation",
    InternalUser = "InternalUser",
    Profile = "Profile",
    Program = "Program",
    ReferenceFile = "ReferenceFile",
    Report = "Report",
    Role = "Role",
    Subscription = "Subscription",
    Upload = "Upload",
    User = "User",
    UserRole = "UserRole",
    Vendor = "Vendor",
    Workflow = "Workflow",
}

export interface PagingOfEntitlementDto {
    count: number;
    data: EntitlementDto[];
}

export interface EntitlementDto {
    id: number;
    name: string;
    enum_value: UnityEntitlement;
    description: string;
}

export interface PagingOfEntitlementMiniDto {
    count: number;
    data: EntitlementMiniDto[];
}

export interface EntitlementMiniDto {
    id: number;
    name: string;
    enum_value: UnityEntitlement;
    description: string;
}

export interface FacetResponseDto {
    resource_type: UnityResourceType;
    facets: UnityFacet[];
}

export enum UnityResourceType {
    Unknown = "Unknown",
    Agency = "Agency",
    Agreement = "Agreement",
    Client = "Client",
    ClientExpense = "ClientExpense",
    Community = "Community",
    Disbursement = "Disbursement",
    Document = "Document",
    FormResponse = "FormResponse",
    FormSchedule = "FormSchedule",
    FormSchema = "FormSchema",
    Program = "Program",
    ReferenceFile = "ReferenceFile",
    RoleMembership = "RoleMembership",
    Subscription = "Subscription",
    User = "User",
    Vendor = "Vendor",
}

export interface UnityFacet {
    property: string;
    display_name: string;
    values: string[];
}

export interface FeatureDto {
    feature_flag: UnityFeatureType;
}

export enum UnityFeatureType {
    PermissionManagement = "PermissionManagement",
    Subscriptions = "Subscriptions",
    RoleManagement = "RoleManagement",
}

export interface FormInstanceCreateDto {
    agreement_id: number;
    form_schedule_id: number;
    open_date: Date;
    due_date?: Date | null;
}

export interface PagingOfFormInstanceDetailedDto {
    count: number;
    data: FormInstanceDetailedDto[];
}

export interface FormInstanceDetailedDto {
    id: number;
    reference_number_display: string;
    form_schema_data: FormSchemaDataDto;
    form_response_data?: FormDataDto | null;
    open_date: Date;
    due_date?: Date | null;
    last_submitted_date?: Date | null;
    form_response?: FormResponseMiniDto | null;
    form_schedule: FormScheduleMiniDto;
    agreement: AgreementMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
    is_overdue: boolean;
    is_untouched: boolean;
    is_draft: boolean;
    is_changes_requested: boolean;
    is_rejected: boolean;
    is_completed: boolean;
    is_pending_approval: boolean;
    is_pending_director_approval: boolean;
    is_submitted: boolean;
    is_open: boolean;
    can_download_pdf: boolean;
}

export interface FormSchemaDataDto {

    [key: string]: any;
}

export interface FormDataDto {

    [key: string]: any;
}

export interface FormResponseMiniDto {
    id: number;
    form_instance_id: number;
    version_id: number;
    is_draft: boolean;
    upload_id?: number | null;
}

export interface FormScheduleMiniDto {
    id: number;
    form_type_id: number;
    days_visible_before_open: number;
    agreement_name: string;
    name: string;
    type_name: string;
    form_type_enum_value: UnityFormType;
    type_enum_value: UnityScheduleType;
    start_date: Date;
    recurrence_rule: string;
}

export enum UnityScheduleType {
    Unknown = "Unknown",
    Adhoc = "Adhoc",
    OneTime = "OneTime",
    Recurring = "Recurring",
}

export interface PagingOfFormInstanceDto {
    count: number;
    data: FormInstanceDto[];
}

export interface FormInstanceDto {
    id: number;
    reference_number_display: string;
    open_date: Date;
    due_date?: Date | null;
    last_submitted_date?: Date | null;
    form_response_id?: number | null;
    form_schedule_id: number;
    agreement_id: number;
    is_overdue: boolean;
    is_untouched: boolean;
    is_draft: boolean;
    is_changes_requested: boolean;
    is_rejected: boolean;
    is_completed: boolean;
    is_pending_approval: boolean;
    is_pending_director_approval: boolean;
    is_submitted: boolean;
    can_download_pdf: boolean;
}

export interface PagingOfFormInstanceMiniDto {
    count: number;
    data: FormInstanceMiniDto[];
}

export interface FormInstanceMiniDto {
    id: number;
    reference_number_display: string;
    open_date: Date;
    due_date?: Date | null;
    last_submitted_date?: Date | null;
}

export interface FormInstanceUpdateDto {
    open_date: Date;
    due_date?: Date | null;
}

export interface FormResponseDetailedDto {
    id: number;
    form_instance: FormInstanceMiniDto;
    form_schema: FormSchemaMiniDto;
    version_id: number;
    data: FormDataDto;
    is_draft: boolean;
    last_submitted_date?: Date | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
    upload?: UploadMiniDto | null;
}

export interface FormResponseDto {
    id: number;
    form_instance_id: number;
    data: FormDataDto;
    version_id: number;
    last_submitted_date?: Date | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    current_state_id: number;
    is_draft: boolean;
    upload_id?: number | null;
}

export interface FormResponseCreateDto {
    agreement_id: number;
    form_schedule_id: number;
    initial_transition_id: number;
    data: FormDataDto;
    form_instance_id?: number | null;
}

export interface FormResponseUpdateDto {
    agreement_id: number;
    form_schedule_id: number;
    data: FormDataDto;
    transition_id?: number | null;
}

export interface PagingOfFormResponseDetailedDto {
    count: number;
    data: FormResponseDetailedDto[];
}

export interface PagingOfFormResponseDto {
    count: number;
    data: FormResponseDto[];
}

export interface PagingOfFormResponseMiniDto {
    count: number;
    data: FormResponseMiniDto[];
}

export interface FormScheduleCreateDto {
    agreement_id: number;
    type_id: number;
    days_visible_before_open: number;
    start_date: Date;
    recurrence_rule?: string | null;
    name: string;
    description: string;
    form_schema_id: number;
}

export interface PagingOfFormScheduleDetailedDto {
    count: number;
    data: FormScheduleDetailedDto[];
}

export interface FormScheduleDetailedDto {
    id: number;
    agreement: AgreementMiniDto;
    name: string;
    description: string;
    form_schema: FormSchemaMiniDto;
    type: ScheduleTypeMiniDto;
    recurrence_rule: string;
    days_visible_before_open: number;
    start_date: Date;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
    form_type: FormTypeMiniDto;
    initial_transitions: TransitionMiniDto[];
}

export interface ScheduleTypeMiniDto {
    id: number;
    name: string;
    enum_value: UnityScheduleType;
}

export interface PagingOfFormScheduleDto {
    count: number;
    data: FormScheduleDto[];
}

export interface FormScheduleDto {
    id: number;
    agreement_id: number;
    name: string;
    description: string;
    form_schema_id: number;
    type_id: number;
    days_visible_before_open: number;
    start_date: Date;
    recurrence_rule: string;
    current_state_id: number;
}

export interface PagingOfFormScheduleMiniDto {
    count: number;
    data: FormScheduleMiniDto[];
}

export interface FormScheduleUpdateDto {
    name: string;
    description: string;
    form_schema_id: number;
}

export interface FormSchemaCreateDto {
    name: string;
    description: string;
    type_id: number;
    default_workflow_id: number;
    data: FormSchemaDataDto;
}

export interface PagingOfFormSchemaDetailedDto {
    count: number;
    data: FormSchemaDetailedDto[];
}

export interface FormSchemaDetailedDto {
    id: number;
    name: string;
    description: string;
    current_state: WorkflowStateMiniDto;
    data: FormSchemaDataDto;
    type: FormTypeMiniDto;
    default_workflow: WorkflowMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export interface WorkflowMiniDto {
    id: number;
    name: string;
    is_system_workflow: boolean;
}

export interface PagingOfFormSchemaDto {
    count: number;
    data: FormSchemaDto[];
}

export interface FormSchemaDto {
    id: number;
    name: string;
    description: string;
    data: FormSchemaDataDto;
    type_id: number;
    default_workflow_id: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    current_state_id: number;
    workflow_id: number;
}

export interface PagingOfFormSchemaMiniDto {
    count: number;
    data: FormSchemaMiniDto[];
}

export interface FormSchemaUpdateDto {
    name: string;
    description: string;
    default_workflow_id: number;
    data: FormSchemaDataDto;
}

export interface PagingOfFormTypeDetailedDto {
    count: number;
    data: FormTypeDetailedDto[];
}

export interface FormTypeDetailedDto {
    id: number;
    name: string;
    enum_value: UnityFormType;
    template_data?: FormSchemaDataDto | null;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export interface PagingOfFormTypeDto {
    count: number;
    data: FormTypeDto[];
}

export interface FormTypeDto {
    id: number;
    name: string;
    enum_value: UnityFormType;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
}

export interface PagingOfFormTypeMiniDto {
    count: number;
    data: FormTypeMiniDto[];
}

export interface PagingOfUploadDto {
    count: number;
    data: UploadDto[];
}

export interface UploadDto {
    id: number;
    file_name: string;
    file_type: string;
    file_size: number;
}

export interface InternalUserCreateDto {
    user_name: string;
    agency_id: number;
    role_id: number;
}

export interface PermissionMaskDto {
    /** The disallow set defined for this context */
    role_mask_set: UnityPermissionFlags;
    /** The disallow set defined by the hierarchy of this context */
    lineage_mask_set: UnityPermissionFlags;
}

export interface UnityPermissionFlags {

    [key: string]: UnityPermissionType | any;
}

export enum UnityPermissionType {
    None = 0,
    View = 1,
    List = 2,
    Create = 4,
    Update = 8,
    Delete = 16,
    Transition = 32,
    All = 63,
}

export interface ProgramCreateDto {
    code: string;
    name: string;
}

export interface PagingOfProgramDetailedDto {
    count: number;
    data: ProgramDetailedDto[];
}

export interface ProgramDetailedDto {
    id: number;
    code: string;
    name: string;
    agreements_count: number;
    total_award_amount: number;
    total_disbursed_amount: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
}

export interface PagingOfProgramDto {
    count: number;
    data: ProgramDto[];
}

export interface ProgramDto {
    id: number;
    code: string;
    name: string;
    agreements_count: number;
    total_award_amount: number;
    total_disbursed_amount: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    current_state_id: number;
}

export interface PagingOfProgramMiniDto {
    count: number;
    data: ProgramMiniDto[];
}

export interface ProgramUpdateDto {
    code: string;
    name: string;
}

export interface ReferenceFileCreateDto {
    name: string;
    agreement_id: number;
    upload_id: number;
}

export interface PagingOfReferenceFileDetailedDto {
    count: number;
    data: ReferenceFileDetailedDto[];
}

export interface ReferenceFileDetailedDto {
    id: number;
    name: string;
    agreement: AgreementMiniDto;
    upload: UploadMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
}

export interface PagingOfReferenceFileDto {
    count: number;
    data: ReferenceFileDto[];
}

export interface ReferenceFileDto {
    id: number;
    name: string;
    agreement_id: number;
    upload_id: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    current_state_id: number;
}

export interface PagingOfReferenceFileMiniDto {
    count: number;
    data: ReferenceFileMiniDto[];
}

export interface ReferenceFileMiniDto {
    id: number;
    name: string;
    agreement_id: number;
    upload_id: number;
}

export interface ReferenceFileUpdateDto {
    name: string;
}

export interface PagingOfReportDetailedDto {
    count: number;
    data: ReportDetailedDto[];
}

export interface ReportDetailedDto {
    id: number;
    name: string;
    enum_value: UnityReport;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export enum UnityReport {
    Unknown = "Unknown",
    AgreementReport = "AgreementReport",
    ClientExpenseReport = "ClientExpenseReport",
    ClientReport = "ClientReport",
    UserReport = "UserReport",
}

export interface PagingOfReportDto {
    count: number;
    data: ReportDto[];
}

export interface ReportDto {
    id: number;
    name: string;
    enum_value: UnityReport;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
}

export interface PagingOfReportMiniDto {
    count: number;
    data: ReportMiniDto[];
}

export interface ReportMiniDto {
    id: number;
    name: string;
    enum_value: UnityReport;
}

export interface RoleCreateDto {
    name: string;
    description: string;
    agency_id: number;
    parent_role_id: number;
}

export interface PagingOfRoleDetailedDto {
    count: number;
    data: RoleDetailedDto[];
}

export interface RoleDetailedDto {
    id: number;
    name: string;
    description: string;
    agency: AgencyMiniDto;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    parent_role?: RoleMiniDto | null;
}

export interface PagingOfRoleDto {
    count: number;
    data: RoleDto[];
}

export interface RoleDto {
    id: number;
    name: string;
    description: string;
    agency_id: number;
    parent_role_id?: number | null;
}

export interface PagingOfRoleMiniDto {
    count: number;
    data: RoleMiniDto[];
}

export interface RoleUpdateDto {
    name: string;
    description: string;
}

export interface PagingOfScheduleTypeDetailedDto {
    count: number;
    data: ScheduleTypeDetailedDto[];
}

export interface ScheduleTypeDetailedDto {
    id: number;
    name: string;
    enum_value: UnityScheduleType;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export interface PagingOfScheduleTypeDto {
    count: number;
    data: ScheduleTypeDto[];
}

export interface ScheduleTypeDto {
    id: number;
    name: string;
    enum_value: UnityScheduleType;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
}

export interface PagingOfScheduleTypeMiniDto {
    count: number;
    data: ScheduleTypeMiniDto[];
}

export interface SubscriptionCreateDto {
    agency_id: number;
    type_id: number;
    user_id: number;
}

export interface PagingOfSubscriptionDetailedDto {
    count: number;
    data: SubscriptionDetailedDto[];
}

export interface SubscriptionDetailedDto {
    id: number;
    agency: AgencyMiniDto;
    type: UnitySubscriptionType;
    user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export enum UnitySubscriptionType {
    Unknown = "Unknown",
    NewUserNotification = "NewUserNotification",
}

export interface PagingOfSubscriptionDto {
    count: number;
    data: SubscriptionDto[];
}

export interface SubscriptionDto {
    id: number;
    agency_id: number;
    type_id: number;
    user_id: number;
    current_state_id: number;
}

export interface PagingOfSubscriptionMiniDto {
    count: number;
    data: SubscriptionMiniDto[];
}

export interface SubscriptionMiniDto {
    id: number;
    agency_id: number;
    type_id: number;
    user_id: number;
    current_state_id: number;
}

export interface TransitionRequestDto {
    id: number;
    /** [Optional] User-defined explanation of the transition. */
    comment?: string | null;
    /** [Optional] User-defined override of of the transition date. */
    date?: Date | null;
}

export interface UploadCreateDto {
    file_name: string;
    file_type: string;
    file_size: number;
}

export interface UserPreferencesDto {
    has_default_agreement: boolean;
    default_agreement_name?: string | null;
    default_agreement_id?: number | null;
}

export interface UserRoleCreatedResponseDto {
    user_id: number;
    role_id: number;
}

export interface UserRoleCreateDto {
    role_id: number;
    user_id: number;
    agency_id: number;
}

export interface PagingOfUserRoleDetailedDto {
    count: number;
    data: UserRoleDetailedDto[];
}

export interface UserRoleDetailedDto {
    id: number;
    is_internal: boolean;
    user: UserMiniDto;
    agency: AgencyMiniDto;
    role: RoleMiniDto;
    current_state: WorkflowStateMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export interface PagingOfUserRoleDto {
    count: number;
    data: UserRoleDto[];
}

export interface UserRoleDto {
    id: number;
    name: string;
    user_id: number;
    user_name: string;
    agency_id: number;
    agency_name: string;
    current_state_id: number;
    current_state_name: string;
    current_state_enum_value: UnityWorkflowState;
    is_administrator: boolean;
    is_unity_administrator: boolean;
    is_internal: boolean;
    is_active: boolean;
}

export interface PagingOfUserRoleMiniDto {
    count: number;
    data: UserRoleMiniDto[];
}

export interface UserRoleMiniDto {
    id: number;
    name: string;
    user_id: number;
    agency_id: number;
    agency_name: string;
    current_state_id: number;
    current_state_name: string;
    current_state_enum_value: UnityWorkflowState;
    is_administrator: boolean;
    is_internal: boolean;
}

export interface UserRoleUpdateDto {
    role_id: number;
}

export interface UserCreateDto {
    user_name: string;
    first_name: string;
    last_name: string;
    agency_id: number;
    role_id: number;
}

export interface PagingOfUserDetailedDto {
    count: number;
    data: UserDetailedDto[];
}

export interface UserDetailedDto {
    id: number;
    user_name: string;
    full_name: string;
    is_internal: boolean;
    current_state: WorkflowStateMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    role_membership_users: UserRoleMiniDto[];
}

export interface PagingOfUserDto {
    count: number;
    data: UserDto[];
}

export interface UserDto {
    id: number;
    user_name: string;
    full_name: string;
    is_internal: boolean;
    current_state_name: string;
    current_state_id: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
}

export interface PagingOfUserMiniDto {
    count: number;
    data: UserMiniDto[];
}

export interface UserStatsDto {
    id: number;
    assigned_agreements_count: number;
    overdue_forms_count: number;
    upcoming_forms_count: number;
    pending_disbursements_count: number;
}

export interface UserUpdateDto {
    full_name: string;
}

export interface VendorCreateDto {
    name: string;
    type_id: number;
    tin: string;
    w9_upload_id?: number;
}

export interface PagingOfVendorDetailedDto {
    count: number;
    data: VendorDetailedDto[];
}

export interface VendorDetailedDto {
    id: number;
    name: string;
    type: VendorTypeMiniDto;
    tin: string;
    w9_upload?: UploadMiniDto;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
    current_state: WorkflowStateMiniDto;
}

export interface VendorTypeMiniDto {
    id: number;
    name: string;
    enum_value: UnityVendorType;
}

export interface PagingOfVendorDto {
    count: number;
    data: VendorDto[];
}

export interface VendorDto {
    id: number;
    name: string;
    type_enum_value: UnityVendorType;
    tin: string;
    w9_upload_id?: number;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
    current_state_id: number;
}

export interface PagingOfVendorMiniDto {
    count: number;
    data: VendorMiniDto[];
}

export interface VendorUpdateDto {
    name: string;
    type_id: number;
    tin: string;
    w9_upload_id?: number;
}

export interface PagingOfVendorTypeDetailedDto {
    count: number;
    data: VendorTypeDetailedDto[];
}

export interface VendorTypeDetailedDto {
    id: number;
    name: string;
    enum_value: UnityVendorType;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export interface PagingOfVendorTypeDto {
    count: number;
    data: VendorTypeDto[];
}

export interface VendorTypeDto {
    id: number;
    name: string;
    enum_value: UnityVendorType;
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user_id: number;
    last_modified_by_user_id: number;
}

export interface PagingOfVendorTypeMiniDto {
    count: number;
    data: VendorTypeMiniDto[];
}

export interface WorkflowHistoryDetailedDto {
    id: number;
    resource_id: number;
    resource_type_enum_value: UnityResourceType;
    comment?: string | null;
    from_state: WorkflowStateMiniDto;
    to_state: WorkflowStateMiniDto;
    created_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_dt: Date;
    last_modified_by_user: UserMiniDto;
}

export interface WorkflowHistoryDto {
    id: number;
    resource_id: number;
    resource_type_enum_value: UnityResourceType;
    comment?: string | null;
    from_state_id: number;
    from_state_name: string;
    from_state_enum_value: UnityWorkflowState;
    to_state_id: number;
    to_state_name: string;
    to_state_enum_value: UnityWorkflowState;
    created_dt: Date;
    created_by_user_id: number;
    created_by_user_user_name: string;
    created_by_user_full_name: string;
}

export interface WorkflowHistoryMiniDto {
    id: number;
    resource_id: number;
    from_state_id: number;
    from_state_name: string;
    to_state_id: number;
    to_state_name: string;
    created_dt: Date;
}

export interface PagingOfWorkflowDetailedDto {
    count: number;
    data: WorkflowDetailedDto[];
}

export interface WorkflowDetailedDto {
    id: number;
    name: string;
    is_system_workflow: boolean;
    workflow_transitions: TransitionMiniDto[];
    created_dt: Date;
    last_modified_dt: Date;
    created_by_user: UserMiniDto;
    last_modified_by_user: UserMiniDto;
}

export interface PagingOfWorkflowDto {
    count: number;
    data: WorkflowDto[];
}

export interface WorkflowDto {
    id: number;
    name: string;
    is_system_workflow: boolean;
}

export interface PagingOfWorkflowMiniDto {
    count: number;
    data: WorkflowMiniDto[];
}

export interface WorkItemDto {
    id: number;
    name: string;
    description: string;
    current_state_enum_value: UnityWorkflowState;
    current_state_name: string;
    is_overdue: boolean;
    severity_type: UnityWorkItemSeverityType;
    due_date?: Date | null;
    agreement_id: number;
    form_type_id: number;
}

export enum UnityWorkItemSeverityType {
    High = "High",
    Medium = "Medium",
    Low = "Low",
}

export interface UserConfirmationDto {
    token: string;
}

export interface ResendUserConfirmationDto {
    username: string;
}

export interface AuthFlowResponseDto {
    grant_type: UnitySessionGrantTypes;
}

export enum UnitySessionGrantTypes {
    ACGv1 = 0,
    ROPGv1 = 1,
}

export interface AuthSessionDto {
    refresh_token: string;
    status: UnitySessionStatus;
    access_token: string;
}

export enum UnitySessionStatus {
    Unknown = 0,
    Success = 1,
    Failed = 2,
    Impersonating = 4,
}

export interface ImpersonationCreateDto {
    username: string;
}

export interface StsAcgUrlResponse {
    grant_type: OAuth2GrantType;
    redirect_uri: string;
}

export enum OAuth2GrantType {
    ACGv1 = "ACGv1",
    ACGv2 = "ACGv2",
    CCGv1 = "CCGv1",
    CCGv2 = "CCGv2",
    ROPGv1_Legacy = "ROPGv1_Legacy",
    ROPGv1 = "ROPGv1",
    ROPGv2 = "ROPGv2",
}

export interface AuthCredentialExchangeDto {
    username: string;
    password: string;
    redirect_url?: string | null;
}

export interface PasswordResetDto {
    success: boolean;
}

export interface PasswordResetRequest {
    user_name: string;
}

export interface AuthMfaCodeExchangeDto {
    username: string;
    mfa_code: string;
    mfa_state: string;
}

export interface UnityBaseContext {
    status: UnitySessionStatus;
    refresh_token_type: string;
    refresh_token: string;
    api_version: string;
    is_logged_in: boolean;
    is_impersonating: boolean;
    environment_name: string;
}

export interface UnityAuthContext extends UnityBaseContext {
    user: UnityContextUser;
    user_roles: UnityContextRole[];
    user_id: number;
    is_unity_admin: boolean;
    is_internal: boolean;
    audit_user_id: number;
}

export function isUnityAuthContext(object: any): object is UnityAuthContext {
    return object && object[''] === 'UnityAuthContext';
}

export interface UnityContextUser {
    user_id: number;
    user_name: string;
    fullname: string;
    is_unity_admin: boolean;
    is_internal: boolean;
}

export interface UnityContextRole {
    id: number;
    name: string;
    user_id: number;
    user_name: string;
    agency_id: number;
    agency_image_url: string;
    agency_name: string;
    current_state_id: number;
    current_state_name: string;
    current_state_enum_value: UnityWorkflowState;
    is_administrator: boolean;
    is_unity_administrator: boolean;
    is_internal: boolean;
    is_active: boolean;
    flags: UnityPermissionFlags;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}